<template>
  <div ref="whole_page" class="pb-5">
    <div @click="backToStudentMenu" v-show="showHomeButton && !isPreview" id="Back-to-menu">
      <feather-icon class="menuIcon" icon="HomeIcon" svg-classes="menuIcon"></feather-icon>      
    </div>

    <!-- <div id="new-back-button">
      <img id="back-arrow" class="newBackButtonIcon" svg-classes="newBackButtonIcon" v-show="isBackAllowed" @click="backToTask" v-if="$route.params.isStudent" src="../../assets/images/digi-back-arrow.png"/>
    </div> -->
    
    <vs-row vs-align="center" vs-type="flex" vs-justify="center" vs-w="12">
      <vs-col vs-w="12">
        
        <!-- <vs-button id="help-btn" @click="helpPopupActive = true" radius color="danger" type="filled" size="large" class="shadow-lg" icon-pack="feather" icon="icon-help-circle" /> -->

        <vx-card id="character-card" v-show="!video.videoUrl && !ispringquiz.id && !presentation.id && !document.id && !upload.id && !navigation.id && !videoCapture.id && !quiz.id && !textNavigation.id && !podcast.id && !videoQuiz.videoUrl" ref="card" vs-align="center" class="backgroundAutoGrow" :style="{ background: 'url(' + currentScene.imageUrl + ')', height: backgroundCardHeight + 'px'}">
          
          <div id="info-display" v-if="story && $route.params.isStudent">
            <img id="back-arrow" v-show="isBackAllowed" @click="backToTask" v-if="$route.params.isStudent" src="../../assets/images/digi-back-arrow.png" :style="{ 'top': (backgroundCardHeight * 0.5) - 30 + 'px' }"/>
            <!-- <div id="health-container">
              <div id="another-div" >
                <feather-icon id="heart-icon" icon="HeartIcon" svg-classes="stroke-current"></feather-icon>
                <div id="health-bar-container">
                  <vx-tooltip :text="story && story.storyDaysRem ? 'Days to reach milestone: ' + story.storyDaysRem : 'Not available'" position="bottom">
                    <vs-progress id="health-bar" :height="12" :percent="story && story.storyPercentageRem ? story.storyPercentageRem : 0" :color="story && story.storyPercentageRem <= 20 ? 'danger' : story && story.storyPercentageRem <= 50 ? 'warning' : story && story.storyPercentageRem <= 100 ? 'success' : story && story.storyPercentageRem <= 0 ? 'light' : 'light'"></vs-progress>
                  </vx-tooltip>
                </div>
                <div id="coin-container">
                  <img id="coin-gif" src="../../assets/images/rotatingcoin.gif"/>
                  <p id="total-coins">{{ studentCoins }}</p>
                </div>
              </div>
            </div> -->
            <div id="backpack-container">
              <img id="backpack-img" @click="openBackpack" src="../../assets/images/backpack.png"/>
            </div>
          </div>
          <div id="characterDiv" :style="{ height: backgroundCardHeight * 0.7 + 'px'}">
            <transition name="fade"><img id="characterLeft" :key="currentCharacterLeft.look.imageUrl" :src="currentCharacterLeft.look.imageUrl" :style="{ height: charHeight + 'px' }" class="float-left ml-4" /></transition>
            <transition name="fade"><img id="characterRight" :key="currentCharacterRight.look.imageUrl" :src="currentCharacterRight.look.imageUrl" :style="{ height: charHeight + 'px' }" class="float-right ml-4" /></transition>
          </div>
          <transition name="fade">
            <div class="speech" :accesskey="currentCharacterLeft.look.imageUrl + currentCharacterRight.look.imageUrl" v-show="showTextBox" ref="dialogBox" id="dialogBox" :style="{ 'font-size': textBoxFontSize + 'pt'}">
              <p @click="nextTask()" class="cursor-pointer speech-text" :style="{ 'border-radius': textBoxEdges + 'px' }">{{currentDialogText}}<br>
                <span id="optionText" class="textStyling" :key="option.taskId" v-for="option in dialogOptions" @click.stop="optionClicked(option)">{{option.text}}<br></span>
              </p>
            </div>
          </transition>
          <vs-button id="help-btn" @click="helpPopupActive = true" radius color="danger" type="filled" size="large" class="shadow-lg" icon-pack="feather" icon="icon-help-circle" />
          <img id="next-task-arrow" @click="nextTask" v-show="!isDisabled && $route.query.mode != 'previewScene'" src="../../assets/images/digi-next-arrow.png" :style="{ 'top': (backgroundCardHeight * 0.5) - 30 + 'px' }"/>
          <!-- <vs-button id="next-task-button" class="mr-3 mb-3" radius color="light" type="border" icon-pack="feather" icon="icon-chevron-right" @click="nextTask" v-show="!isDisabled"></vs-button> -->
          <audio v-if="dialogAudioUrl" ref="dialogspeech" :src="dialogAudioUrl" autoplay="autoplay" />
        </vx-card>

        <!-- <div v-show="vimeoPlayer"> -->
        <div v-show="video.videoUrl && video.videoUrl.includes('vimeo')">
          <vx-card class="overflow-hidden contentCards" vs-align="center" :style="{ height: backgroundCardHeight + 'px', width: backgroundCardWidth + 'px'}">
          
            <template slot="no-body">
              <img id="back-arrow" v-show="isBackAllowed" @click="backToTask" v-if="$route.params.isStudent" src="../../assets/images/digi-back-arrow.png" :style="{ 'top': (backgroundCardHeight * 0.5) - 30 + 'px' }"/>
              <!-- <iframe
                id="videoFrame"
                :src="url"
                :style="{ height: backgroundCardHeight + 'px', width: backgroundCardWidth + 'px'}"
              ></iframe> -->
              <div id="videoFrame"></div>
              <vs-button id="help-btn" @click="helpPopupActive = true" radius color="danger" type="filled" size="large" class="shadow-lg" icon-pack="feather" icon="icon-help-circle" />
              <img id="next-task-arrow" @click="nextTask" v-show="!isNextTaskBtnHidden" src="../../assets/images/digi-next-arrow.png" :style="{ 'top': (backgroundCardHeight * 0.5) - 30 + 'px' }"/>
            </template>
          </vx-card>
        </div>

        <div v-show="video.videoUrl && video.videoUrl.includes('you')">
          <vx-card class="overflow-hidden contentCards" vs-align="center" :style="{ height: backgroundCardHeight + 'px', width: backgroundCardWidth + 'px'}">
            <template slot="no-body">
              <img id="back-arrow" v-show="isBackAllowed" @click="backToTask" v-if="$route.params.isStudent" src="../../assets/images/digi-back-arrow.png" :style="{ 'top': (backgroundCardHeight * 0.5) - 30 + 'px' }"/>
              <youtube ref="youtubePlayer" :video-id="youtubeVideoId" :player-vars="{ autoplay: 1 }" @ended="isNextTaskBtnHidden = false" :player-width="backgroundCardWidth" :player-height="backgroundCardHeight"></youtube>
              <vs-button id="help-btn" @click="helpPopupActive = true"  radius color="danger" type="filled" size="large" class="shadow-lg" icon-pack="feather" icon="icon-help-circle" />
              <img id="next-task-arrow" @click="nextTask" v-show="!isNextTaskBtnHidden" src="../../assets/images/digi-next-arrow.png" :style="{ 'top': (backgroundCardHeight * 0.5) - 30 + 'px' }"/>
            </template>
          </vx-card>
        </div>

        <div v-show="video.videoUrl && (video.videoUrl.includes('spesres') || (video.videoUrl.includes('digicampus') && !video.videoUrl.includes('content.digicampus.co.za')))">
          <vx-card ref="extVideoPlayerCard" class="overflow-hidden contentCards vs-con-loading__container" vs-align="center" :style="{ height: '90vh'}">
            <template slot="no-body">
              <img id="back-arrow" v-show="isBackAllowed" @click="backToTask" v-if="$route.params.isStudent" src="../../assets/images/digi-back-arrow.png" :style="{ 'top': (backgroundCardHeight * 0.5) - 30 + 'px' }"/>
              <video id="externalPlayer" class="media-video-player card-video" controls />
              <vs-button id="help-btn" @click="helpPopupActive = true"  radius color="danger" type="filled" size="large" class="shadow-lg" icon-pack="feather" icon="icon-help-circle" />
              <img id="next-task-arrow" @click="nextTask" v-show="!isNextTaskBtnHidden" src="../../assets/images/digi-next-arrow.png" :style="{ 'top': (backgroundCardHeight * 0.5) - 30 + 'px' }"/>
            </template>
          </vx-card>
        </div>
      
        <div v-show="video.videoUrl && video.videoUrl.includes('content.digicampus.co.za')" class="player">
          <div id="videojs-container"  class="text-center">
              <img id="back-arrow__hls" style="top: calc(39vh - 30px);" v-show="isBackAllowed" @click="backToTask" v-if="$route.params.isStudent" src="../../assets/images/digi-back-arrow.png" />
              <video id="m3u8-player" class="video-js" ref="videojs" autoplay controls></video>
              <vs-button id="help-btn" @click="helpPopupActive = true"  radius color="danger" type="filled" size="large" class="shadow-lg" icon-pack="feather" icon="icon-help-circle" />
              <img id="next-task-arrow__hls" style="top: calc(39vh - 30px);" @click="nextTask" v-show="!isNextTaskBtnHidden" src="../../assets/images/digi-next-arrow.png"/>
          </div>
        </div>

        <!-- <div v-show="videoPlayer"> -->
        <div v-show="video.videoUrl && !video.videoUrl.includes('vimeo') && !video.videoUrl.includes('you') && !video.videoUrl.includes('spesres') && !video.videoUrl.includes('digicampus') && !video.videoUrl.includes('content.digicampus.co.za')">
          <vx-card ref="videoPlayerCard" class="overflow-hidden contentCards vs-con-loading__container" vs-align="center" :style="{ height: '90vh'}">
            <template slot="no-body">
              <img id="back-arrow" v-show="isBackAllowed" @click="backToTask" v-if="$route.params.isStudent" src="../../assets/images/digi-back-arrow.png" :style="{ 'top': '50%' }"/>
              <video id="player" class="media-video-player card-video" controls />
              <vs-button id="help-btn" @click="helpPopupActive = true" radius color="danger" type="filled" size="large" class="shadow-lg" icon-pack="feather" icon="icon-help-circle" />
              <img id="next-task-arrow" @click="nextTask" v-show="!isNextTaskBtnHidden" src="../../assets/images/digi-next-arrow.png" :style="{ 'top': '50%'}"/>
            </template>
          </vx-card>
        </div>

        <div v-show="ispringquiz.id" style="text-align: center;margin-left:-2rem">
          <img id="back-arrow" v-show="isBackAllowed" @click="backToTask" v-if="$route.params.isStudent" src="../../assets/images/digi-back-arrow.png" :style="{ 'top': '50%' }"/>
          <iframe id="ispringQuizFrame" :src="ispringQuizUrl" style="height: 90vh;width: 99vw;" frameborder="0" allowfullscreen="true" mozallowfullscreen="true" webkitallowfullscreen="true"></iframe>
          <vs-button id="help-btn" @click="helpPopupActive = true" radius color="danger" type="filled" size="large" class="shadow-lg" icon-pack="feather" icon="icon-help-circle" />
          <img id="next-task-arrow" @click="nextTask" v-show="!isDisabled" src="../../assets/images/digi-next-arrow.png" :style="{ 'top': '50%' }"/>
        </div>

        <div v-show="presentation.id">
          <vx-card class="overflow-hidden contentCards" vs-align="center" :style="{ height: '90vh'}">
            <template slot="no-body">
              <img id="back-arrow" v-show="isBackAllowed" @click="backToTask" v-if="$route.params.isStudent" src="../../assets/images/digi-back-arrow.png" :style="{ 'top': '50%' }"/>
              <iframe id="presentationFrame" :src="presentationUrl" :style="{ height: '100%', width: '100%'}" frameborder="0" allowfullscreen="true" mozallowfullscreen="true" webkitallowfullscreen="true"></iframe>
              <img id="next-task-arrow" @click="nextTask" v-show="!isDisabled && !styleB" src="../../assets/images/digi-next-arrow.png" :style="{ 'top': '50%' }"/>
            </template>
          </vx-card>
          <div v-if="$acl.check('Student') && styleB" class="completebuttonstylebupload mt-3">
            <div class="flex next_btns__container justify-center">
              <vs-button id="completetask-btn" class="vs-con-loading__container next_btns clickbuttonactive" 
                ref="submit_btn" icon-pack="feather" icon="icon-arrow-right" icon-after
                @click="backToTask">
                Complete
              </vs-button>
            </div>
          </div>
        </div>
        <div v-show="document.id">
          <div v-if="numPages" id="zoom-slider" class="flex">
            <feather-icon id="zoom-out-icon" class="mr-3 cursor-pointer" icon="MinusIcon" svg-classes="stroke-current" @click="zoomLevel >= 20 ? zoomLevel = zoomLevel - 10 : zoomLevel = zoomLevel"></feather-icon>
            <vs-slider :min="10" :max="100" :step="10" v-model="zoomLevel"/>
            <feather-icon id="zoom-in-icon" class="ml-3 cursor-pointer" icon="PlusIcon" svg-classes="stroke-current" @click="zoomLevel <= 90 ? zoomLevel = zoomLevel + 10 : zoomLevel = zoomLevel"></feather-icon>
            <span class="ml-4 text-white h-auto self-center"><strong>{{zoomLevel}}%</strong></span>
          </div>
          <div v-if="numPages" id="zoom-slider_mobile">
            <feather-icon id="zoom-out-icon" class="mr-3 cursor-pointer" icon="MinusIcon" svg-classes="stroke-current" @click="zoomLevel >= 20 ? zoomLevel = zoomLevel - 10 : zoomLevel = zoomLevel"></feather-icon>
            <feather-icon id="zoom-in-icon" class="ml-3 cursor-pointer" icon="PlusIcon" svg-classes="stroke-current" @click="zoomLevel <= 90 ? zoomLevel = zoomLevel + 10 : zoomLevel = zoomLevel"></feather-icon>
            <span class="ml-4 text-white h-auto self-center"><strong>{{zoomLevel}}%</strong></span>
          </div>
          <!-- <vs-button v-if="document.downloadable" id="doc-dwnld-btn" @click="downloadPinnedDoc(documentUrl)" color="success" radius type="filled" size="large" class="shadow-lg" icon-pack="feather" icon="icon-download"/> -->
          <div v-if="document.scrollable" :style="{ 'max-width': zoomLevel + '%'}" style="padding-top: 4rem;" class="mx-auto">
            <vs-progress v-if="!numPages" :height="6" indeterminate color="success"></vs-progress>
            <div v-if="document.downloadable" id="paging-buttons_container">
              <div style="position:relative;min-height:100%;">
                <div style="position: absolute;bottom: 50px;left: 0;right: 0;">
                  <vx-card id="paging-card_scroll" style="margin: auto;">
                    <div class="vx-row mx-auto">
                      <div class="vx-col w-full">
                        <div class="flex justify-center" style="align-items: baseline;">
                          <span><vs-button icon-pack="feather" icon="icon-download" color="success" radius @click="downloadPinnedDoc(documentUrl)" /></span>
                        </div>
                      </div>
                    </div>
                  </vx-card>
                </div>
              </div>
            </div>
            <div id="pdf-element" v-if="numPages">
              <pdf
                v-for="(_page, index) in numPages"
                :key="index"
                :src="documentUrl"
                :page="_page"
                @link-clicked="_page = $event"
              ></pdf>
            </div>
            <img id="next-task-arrow" class="next-button-margin-bottom-document" style="bottom: 17px; position: fixed !important;" @click="nextTask" v-show="!isDisabled" src="../../assets/images/digi-next-arrow.png" :style="{ 'z-index':'9999'}"/>        
            <img id="back-arrow" class="back-button-margin-bottom-document" style="position: fixed !important;" v-show="isBackAllowed" @click="backToTask" v-if="$route.params.isStudent" src="../../assets/images/digi-back-arrow.png" :style="{ 'left': '2%', 'z-index':'9999' }"/>
            <vs-button id="help-btn" @click="helpPopupActive = true" radius color="danger" type="filled" size="large" class="shadow-lg" icon-pack="feather" icon="icon-help-circle" />
          </div>
          <div v-else style="padding-top: 4rem;text-align: -webkit-center;" class="mx-auto">
            <vs-progress v-if="loadedRatio != 1" :height="6" :percent="Math.floor(loadedRatio * 100)" color="success"></vs-progress>
            <div id="paging-buttons_container">
              <img id="next-task-arrow" class="next-button-margin-bottom-document" style="bottom: 17px;" @click="nextTask" v-show="!isDisabled" src="../../assets/images/digi-next-arrow.png" :style="{ 'z-index':'9999'}"/>        
              <img id="back-arrow" class="back-button-margin-bottom-document" v-show="isBackAllowed" @click="backToTask" v-if="$route.params.isStudent" src="../../assets/images/digi-back-arrow.png" :style="{ 'left': '2%', 'z-index':'9999' }"/>
              <div id="prev-btn_container">
                <vs-button id="prev-page-btn" @click="page > 1 ? prevPage():''" size="large" radius icon-pack="feather" v-show="page != 1" icon="icon-arrow-left" />
                </div>
              <div id="next-btn_container">
                <vs-button id="next-page-btn" @click="page <= numPages-1 ? nextPage() : '' " size="large" radius icon-pack="feather" v-show="page != numPages" icon="icon-arrow-right" />
              </div>
              <div style="position:relative;min-height:100%;">
                <div style="position: absolute;bottom: 50px;left: 0;right: 0;">
                  <vx-card id="paging-card">
                    <div class="vx-row mx-auto">
                      <div class="vx-col w-full">
                        <div class="flex justify-center" style="align-items: baseline;">
                          <span v-if="document.downloadable" class="mr-2"><vs-button icon-pack="feather" icon="icon-download" color="success" radius @click="downloadPinnedDoc(documentUrl)" /></span>
                          <vs-input size="small" type="number" style="width:60px" v-model.number="page" />
                          <span class="text-white" style="font-size: 12pt;" :style="{ 'margin-bottom': document.downloadable ? '5px' : '3px' }">&nbsp;/&nbsp;<strong>{{numPages}}</strong></span>
                          <span v-if="document.downloadable" class="ml-2"><vs-button icon-pack="feather" icon="icon-printer" color="primary" radius @click="findPrint()" /></span>
                        </div>
                      </div>
                    </div>
                  </vx-card>
                </div>
              </div>
            </div>
            <div :style="{ 'max-width': zoomLevel + '%'}">
              <pdf id="pdf-element" ref="pdf" style="" 
                :src="documentUrl" 
                :page="page" 
                :rotate="rotate" 
                @progress="loadedRatio = $event" 
                @error="error" 
                @num-pages="numPages = $event" 
                @link-clicked="page = $event">
              </pdf>
            </div>
          </div>
          <vs-button id="help-btn" @click="helpPopupActive = true" radius color="danger" type="filled" size="large" class="shadow-lg" icon-pack="feather" icon="icon-help-circle" />
        </div>

        <div v-show="upload.id">
          <vx-card id="upload-card" :title="upload.title" class="contentCards" vs-align="center" :style="{ height:'90vh', 'max-height':'90vh', overflow:'auto'}">
            <img id="back-arrow" v-show="isBackAllowed" @click="backToTask" v-if="$route.params.isStudent" src="../../assets/images/digi-back-arrow.png" :style="{ 'top': '50%' }"/>
            <img id="next-task-arrow" @click="nextTask" style="position: absolute !important; right: 0 !important; " v-show="!isDisabled" src="../../assets/images/digi-next-arrow.png" :style="{ 'top': '50%'}"/>
            <div v-html="upload.content"></div>
              <div class="w-full mt-6" v-if="upload.id && upload.documents.length > 0">
                <div id="AdditionalResources">
                  <h6 class="mb-1">Additional Resources</h6>
                    <div v-for="(_document, index) in upload.documents" :key="index">
                      <div style="display: flex; align-items: center;">
                        <div style="border-right-style: solid; border-right-width: 1px; border-right-color: #cacaca;">
                          <vs-button class="mr-2" color="success" type="filled" size="small" icon-pack="feather" icon="icon-download" @click="downloadPinnedDoc(_document.url)"></vs-button>
                        </div>
                        <div class="ml-2">
                          <p><strong>{{ _document.url.substring(_document.url.indexOf('_') + 1) }}</strong></p>
                        </div>
                      </div>
                    </div>
                </div>                
              </div>          
            <div class="vx-col w-full">
              <div v-show="timeCapture.captureTimeForAssessments && $siteTypeId() != 1" class="hoursUsed mb-8 mt-4">
                <p class="mb-2"> How many hours did you spend preparing for the assessment? </p>
                <vue-slider
                  class="w-full mb-5"
                  :tooltip="'none'"
                  v-model="timeCaptureOnUploadTask"
                  :adsorb="true"
                  :min="timeCapture.taskClassificationTypeId == 1 ? timeCapture.sliderMinFormatives : timeCapture.sliderMinSummatives"
                  :max="timeCapture.taskClassificationTypeId == 1 ? timeCapture.sliderMaxFormatives : timeCapture.sliderMaxSummatives"
                  :data-label="'id'"
                  :data-value="'id'"
                  :marks="true"
                ></vue-slider>
              </div>
              <div v-show="timeActive && !timeCapture.captureTimeForAssessments && this.$siteTypeId() != 1" class="hoursUsed mb-8">
                <label>Hours Spent {{slidervalue}}</label>
                <vue-slider
                  :tooltip="'none'"
                  v-model="slidervalue"
                  :adsorb="true"
                  :data="sliderData.filter(x=> x.number >= upload.minimumTime)"
                  :data-label="'id'"
                  :data-value="'id'"
                  :marks="true"
                  class="w-full mb-4"
                ></vue-slider>
              </div>
              <div class="vx-row" id="uploadTask">
                <div class="vx-col w-1/3 mx-auto  self-center">
                  <file-pond
                    v-show="upload.id"
                    id="cover-filepond"
                    ref="fileUpload"
                    :accepted-file-types="types" 
                    label-idle="Upload new file here"
                    :server="uploadLocation"
                    :name="'file'"
                    :preview="false"
                    :allow-multiple="false"
                    :allow-image-preview="false"
                    :instant-upload="true"
                    @processfile="uploadComplete"
                    @removefile="fileRemoved"
                  />
                </div>
              </div>
              <div>
                <vs-table ref="uploadsTable" single max-items="5" pagination :data="uploadedFiles">
                  <template slot-scope="{data}">
                    <vs-tr :data="uploadedFiles" :key="indextr" v-for="(file, indextr) in data">
                      <vs-td>
                        <img :src="setFileThumb(file)" width=30px class="product-img" />
                      </vs-td>
                      <vs-td>
                        <p class="product-name font-medium">{{ file.substring(file.lastIndexOf('/') + 1) }}</p>
                      </vs-td>
                      <vs-td>
                        <vs-button color="danger" type="flat" icon-pack="feather" icon="icon-trash" @click="uploadedFiles.splice(indextr,1)"></vs-button>
                      </vs-td>
                    </vs-tr>
                  </template>
                </vs-table>
              </div>
            </div>
            <vs-button id="help-btn" @click="helpPopupActive = true" radius color="danger" type="filled" size="large" class="shadow-lg" icon-pack="feather" icon="icon-help-circle" />
            
          </vx-card>
        </div>

        <div v-show="navigation.id">
          <vx-card id="navigation-card" vs-align="center" class="backgroundAutoGrow" :style="{ background: 'url(' + currentScene.imageUrl + ') ', height: backgroundCardHeight + 'px', width: backgroundCardWidth + 'px', 'background-size' : backgroundCardWidth + 'px auto'}">
            <div id="info-display" v-if="story && $route.params.isStudent">
              <img id="back-arrow" v-show="isBackAllowed" @click="backToTask" v-if="$route.params.isStudent" src="../../assets/images/digi-back-arrow.png" :style="{ 'top': '50%' }"/>
              <!-- <div id="health-container">
                <div id="another-div" >
                  <feather-icon id="heart-icon" icon="HeartIcon" svg-classes="stroke-current"></feather-icon>
                  <div id="health-bar-container">
                    <vx-tooltip :text="story && story.storyDaysRem ? 'Days to reach milestone: ' + story.storyDaysRem : 'Not available'" position="bottom">
                      <vs-progress id="health-bar" :height="12" :percent="story && story.storyPercentageRem ? story.storyPercentageRem : 0" :color="story && story.storyPercentageRem <= 20 ? 'danger' : story && story.storyPercentageRem <= 50 ? 'warning' : story && story.storyPercentageRem <= 100 ? 'success' : story && story.storyPercentageRem <= 0 ? 'light' : 'light'"></vs-progress>
                    </vx-tooltip>
                  </div>
                  <div id="coin-container">
                    <img id="coin-gif" src="../../assets/images/rotatingcoin.gif"/>
                    <p id="total-coins">{{ studentCoins }}</p>
                  </div>
                </div>
              </div> -->
              <div id="backpack-container">
                <img id="backpack-img" @click="openBackpack" src="../../assets/images/backpack.png"/>
              </div>
            </div>

            <div class="circular">
              <svg id="map" :height="backgroundCardHeight + 'px'" :width="backgroundCardWidth + 'px'" style="display: inline; margin-left: -21px; margin-top: -21px">
                <g class="map-location">
                  <a id="state_ba" class="state" :key="index" v-for="(location, index) in mapLocations">
                    <polygon id="shape_ba" @click="mapLocationClicked(location)" class="shape" :points="location ? location.coordinates : ''" />
                  </a>
                </g>
              </svg>
            </div>
            <template slot="no-body">
              <vs-button id="help-btn" @click="helpPopupActive = true" radius color="danger" type="filled" size="large" class="shadow-lg" icon-pack="feather" icon="icon-help-circle" />
            </template>
          </vx-card>
        </div>

        <div v-show="videoCapture.id">
          <vx-card id="videocapture-card" :title="videoCapture.title" class="overflowCardScroll contentCards" vs-align="center" :style="{ height: '90vh' , overflow: 'auto !important'}">
            <img id="next-task-arrow" @click="nextTask" v-show="!isDisabled && !styleB" src="../../assets/images/digi-next-arrow.png" style="position: absolute !important; top:50%; right: 0 !important;"/>
            <img id="back-arrow" v-show="isBackAllowed && !styleB" @click="backToTask" v-if="$route.params.isStudent" src="../../assets/images/digi-back-arrow.png" :style="{ 'top': '50%' }"/>

            <div v-html="videoCapture.description" :style="{ }"></div>
            <div class="videoCaptureContainer" :style="{}">
              <iframe id="videocaptureFrame" :src="videoCaptureIframeUrl" frameborder="0" allowfullscreen="true" mozallowfullscreen="true" webkitallowfullscreen="true" allow="microphone; camera" style="width:100%; height:100%; overflow: hidden" ></iframe>
            </div>
            <vs-divider position="center">
              OR
            </vs-divider>
            <div class="flex flex-wrap vs-con-loading__container items-center justify-center pb-4">
              <v-uploader position="center" v-show="videoCapture.id" @done="successUploadVideoRecording" button-text="Upload Files" ref="videoUpload" fileTypeExts="mp4,mov,wmv,webm" :itemLimit=1 language="en" :multiple="false" file-size-limit="100MB" :preview="false"></v-uploader>
            <vs-row>
              <p style="color:green">
                <strong>
                  <h5  :style="{}">
                    Results:
                  </h5>
                </strong>
                <strong>
                  {{messageType == "uploadType" ? "Successfully Uploaded a video" : messageType == "recordType" ? "Successfully Recorded a video" : " " }}
                </strong>
              </p>
            </vs-row>

            <div v-show="timeCapture.captureTimeForAssessments && $siteTypeId() != 1" class="hoursUsed mb-8 mt-4">
              <p class="mb-2"> How many hours did you spend preparing for the assessment? </p>
              <vue-slider
                class="w-full mb-5"
                :tooltip="'none'"
                v-model="timeCaptureOnVideoCaptureTask"
                :adsorb="true"
                :min="timeCapture.taskClassificationTypeId == 1 ? timeCapture.sliderMinFormatives : timeCapture.sliderMinSummatives"
                :max="timeCapture.taskClassificationTypeId == 1 ? timeCapture.sliderMaxFormatives : timeCapture.sliderMaxSummatives"
                :data-label="'id'"
                :data-value="'id'"
                :marks="true"
              ></vue-slider>
            </div>

            </div>
            <vs-button id="help-btn" @click="helpPopupActive = true" radius color="danger" type="filled" size="large" class="shadow-lg" icon-pack="feather" icon="icon-help-circle" />
            
            <div class="completebuttonstylebupload">
              <div class="flex next_btns__container justify-center">
                <vs-button v-show="$acl.check('Student') && styleB && !isDisabled" id="completetask-btn" class="vs-con-loading__container next_btns clickbuttonactive" 
                  ref="submit_btn" icon-pack="feather" icon="icon-arrow-right" icon-after
                  @click="backToTask">
                  Complete
                </vs-button>
              </div>
            </div>

          </vx-card>
        </div>

        <course-viewer-quiz :isCardActive="courseViewerQuiz"
                            :quiz="quiz"
                            :rewrite="rewrite"
                            :cardHeight="backgroundCardHeight"
                            :cardWidth="backgroundCardWidth"
                            :uuid="uuid"
                            @finishQuiz="quizFinished"
                            @nextTask="nextTask"
                            @backToTask="backToTask"
                            :isBackAllowed="isBackAllowed"
                            :errorDataProp="errorData"
                            :taskTypeId="tasktypeId"
                            :userIdProp="currentUserId"
                            :taskIdProp="currentTaskId"
                            :cameras="devices"
                            :logData="logData"
                            @hideHomeButton="hideHomeButton"
                            @hideBackButton="hideBackButton"
                            :resetQuizButtons="resetQuizButtons"
                            @backToStudentMenu="backToStudentMenu"
                            :moduleId="currentModuleId"
                            :styleB="styleB"
                            :timeCapture="timeCapture"
                            />

        <web-cam v-if="webcamStarted" v-show="false" ref="webcam" width="100%" :deviceId="deviceId" @error="onError" @cameras="onCameras" :isFrontCam="true" :debug="true"/>

        <div v-show="textNavigation.id">
          <img id="back-arrow" v-show="isBackAllowed" @click="backToTask" v-if="$route.params.isStudent" src="../../assets/images/digi-back-arrow.png" :style="{ 'top': '50%' }"/>
          <vx-card id="textnavigation-card" class="moibleview" vs-align="center" :style="{ background: 'url(' + currentScene.imageUrl + ')', width:'100%', height:'100vh'}" style="overflow: auto">
            
            <div class="title navtaskheadings">
              <h2 style="word-break:break-word">{{textNavigation.title}}</h2>
              <p style="word-break:break-word" v-html="textNavigation.description" ></p>
            </div><br>
            <div id="info-display" v-if="story && $route.params.isStudent">
              
              <!-- <div id="health-container">
                <div id="another-div" >
                  <feather-icon id="heart-icon" icon="HeartIcon" svg-classes="stroke-current"></feather-icon>
                  <div id="health-bar-container">
                    <vx-tooltip :text="story && story.storyDaysRem ? 'Days to reach milestone: ' + story.storyDaysRem : 'Not available'" position="bottom">
                      <vs-progress id="health-bar" :height="12" :percent="story && story.storyPercentageRem ? story.storyPercentageRem : 0" :color="story && story.storyPercentageRem <= 20 ? 'danger' : story && story.storyPercentageRem <= 50 ? 'warning' : story && story.storyPercentageRem <= 100 ? 'success' : story && story.storyPercentageRem <= 0 ? 'light' : 'light'"></vs-progress>
                    </vx-tooltip>
                  </div>
                  <div id="coin-container">
                    <img id="coin-gif" src="../../assets/images/rotatingcoin.gif"/>
                    <p id="total-coins">{{ studentCoins }}</p>
                  </div>
                </div>
              </div> -->
              <div id="backpack-container">
                <img id="backpack-img" @click="openBackpack" src="../../assets/images/backpack.png"/>
              </div>
            </div>

            <div class="flex flex-wrap vs-con-loading__container items-center justify-center pb-4 textOptionSizing">
              <div id="optionContainer" class="speech-text" :style="{ 'border-radius': textBoxEdges + 'px' }">
                <div id="textNavOptionText" class="textStyling" :key="option.taskId" v-for="option in textNavOptions" @click.stop="textNavOptionClicked(option)"><vs-divider class="optionListDivider" />{{option.text}}<vs-divider class="optionListDivider" /></div>
              </div>
            </div>

            <vs-button id="help-btn" @click="helpPopupActive = true" radius color="danger" type="filled" size="large" class="shadow-lg" icon-pack="feather" icon="icon-help-circle" />

          </vx-card>
        </div>

        <div v-show="podcast.podcastUrl">
          <vx-card ref="podcastPlayerCard" class="overflow-hidden contentCards vs-con-loading__container" vs-align="center" :style="{ height: '50vh'}">
            <template slot="no-body">
              <img id="back-arrow" v-show="isBackAllowed" @click="backToTask" v-if="$route.params.isStudent" src="../../assets/images/digi-back-arrow.png"/>
              <video id="podcastPlayer" class="media-video-player card-video" controls />
              <img id="next-task-arrow" style="position: absolute !important;  right: 0 !important; bottom: 0;" @click="nextTask" v-show="!isNextTaskBtnHidden" src="../../assets/images/digi-next-arrow.png"/>
            </template>
            
          </vx-card>
        </div>

        <div v-show="videoQuiz.videoUrl && videoQuiz.videoUrl.includes('content.digicampus.co.za')" class="player">
          <div id="quiz-videojs-container"  class="text-center">
            <img id="back-arrow__hls" style="top: calc(39vh - 30px);"  @click="backToTask" v-if="$route.params.isStudent" src="../../assets/images/digi-back-arrow.png" />
            <video id="quiz-m3u8-player" class="video-js quiz-player" ref="video_quiz_videojs" autoplay controls ></video>
            
            <img id="next-task-arrow__hls" style="top: calc(39vh - 30px);" @click="nextTask" v-show="!isNextTaskBtnHidden" src="../../assets/images/digi-next-arrow.png"/>
          </div>
        </div>

      </vs-col>
    </vs-row>

    <vs-popup title="Are you sure?" :active.sync="goHomeActive">
      <p class="pb-2">You will have to restart your quiz if you quit</p>
      <div class="mt-3">
        <vs-button color="warning" class="float-right ml-2" @click="goHomeActive = false">Cancel</vs-button>
      </div>
      <div class="mt-3">
        <vs-button color="success" class="float-right" @click="confirmHome">Confirm</vs-button>
      </div>
    </vs-popup>

    <vs-popup id="backpack-popup" fullscreen title="" style="z-index: 50000;" :active.sync="backpackPopupActive">
      <div class="vx-row stack-divs">
        <div id="backpack-contents-container" class="vx-col w-1/2 sm-full-width" style="color: black;">
          <div id="inner-components-container" style="border-radius: 5px">
            <div style="text-align: center;">
              <h4 class="mb-4" style="color: black;">Contents</h4>
            </div>
            <div class="vx-col w-full mb-2 mt-2">
              <vs-table class="vs-con-loading__container" ref="backpackDocsTable" single max-items="10" @selected="openSelectedTask" pagination search :data="backpackDocs">
                <template slot-scope="{data}">
                  <vs-tr :data="file" :key="indextr" v-for="(file, indextr) in data" class="rowcolor">
                    <vs-td>
                      <img v-if="file.taskTypeId == 2" src="../../assets/images/video-icon.png" height="40px" >
                      <img v-else-if="file.taskTypeId == 4" src="../../assets/images/presentation-icon.png" height="40px" >
                      <img v-else src="../../assets/images/document-icon.png" height="40px" >
                    </vs-td>
                    <vs-td :data="data[indextr].taskName">
                      <p class="product-name font-medium">{{file.taskName}}</p>
                    </vs-td>
                    <vs-td>
                      <vs-button color="#727272" type="flat" icon-pack="feather" icon="icon-send" @click.stop="emailTask(file.fileUrl)"></vs-button>
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
            </div>
          </div>
        </div>
        <div id="backpack-notes-container" class="vx-col w-1/2 sm-full-width" style="color: black;">
          <div id="inner-components-container" style="border-radius: 5px">
            <div v-show="notesMode == 'list'">
              <div style="text-align: center;">
                <h4 class="mb-4" style="color: black;">Notes</h4>
              </div>
              <div class="vx-col w-full mb-2 mt-2">
                <vs-table class="vs-con-loading__container" ref="backpackNotesTable" single max-items="10" pagination search @selected="editNote" :data="backpackNotes">
                  <div slot="header">
                    <div>
                      <vs-button @click="addNewNote" color="success" type="flat" icon-pack="feather" icon="icon-plus" text-color="#28C76F">Add Note</vs-button>
                    </div>
                  </div>
                  <template slot-scope="{data}">
                    <vs-tr :data="note" :key="indextr" v-for="(note, indextr) in data" class="rowcolor">
                      <vs-td>
                        <img src="../../assets/images/note-icon.png" height="40px" >
                      </vs-td>
                      <vs-td :data="data[indextr].title">
                        <p class="product-name font-medium">{{note.title}}</p>
                      </vs-td>
                      <vs-td>
                        <vs-button color="#727272" type="flat" icon-pack="feather" icon="icon-mail"></vs-button>
                      </vs-td>
                    </vs-tr>
                  </template>
                </vs-table>
              </div>
            </div>
            <div v-show="notesMode == 'addedit'">
              <div style="text-align: center;">
                <h4 class="mb-4" style="color: black;">{{ noteHeading }}</h4>
              </div>
              <div class="vx-col w-full mb-2 mt-2">
                <label style="color: black;">Title</label>
                <vs-input id="note-title" autocomplete="off" v-validate="'required'" v-model="noteData.title" class="w-full mb-3"/>
                <label style="color: black;">Content</label>
                <quill-editor class="transparent-bg_black" v-model="noteData.body" :options="editorOption" />
              </div>
              <div class="vx-row mt-4">
                <vs-spacer></vs-spacer>
                <div class="vx-col">
                  <vs-button size="small" color="success" type="filled" class="mr-3 mb-2 vs-con-loading__container" ref="saveNoteButton" :disabled="!noteData.title" @click="saveNote">Save</vs-button>
                  <vs-button size="small" color="danger" type="filled" v-show="noteData.id" class="mr-5 mb-2 vs-con-loading__container" @click="deleteNote" ref="deleteNoteButton">Delete</vs-button>
                  <vs-button size="small" color="warning" type="filled" class="mb-2" @click="closeNote">Cancel</vs-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </vs-popup>

    <vs-popup title="Having some problems?" :active.sync="helpPopupActive">
      <p class="pb-2">Please tell us about the issues you are experiencing:</p>
      <vs-textarea v-model="errorData.userMessage" />
      <p class="pb-2">Your WhatsApp number:</p>
      <vs-input autocomplete="off" v-validate="'digits:10'" name="WhatsApp number" v-model="errorData.whatsappNumber" />
      <span class="text-danger text-sm" v-show="errors.has('WhatsApp number')">{{ errors.first('WhatsApp number') }}</span>
      <div class="mt-3">
        <vs-button color="success" class="float-right" @click="submitIssue">Submit</vs-button>
      </div>
    </vs-popup>

    <vs-popup 
      title="Cannot Continue"
      id="formative-assessments-marked-popup" 
      :active.sync="isTaskBlocked">
      <p class="pb-2">Well done on completing your Formative Assessments! Your answers will be assessed by a registered Assessor. You will receive a notification regarding the outcome.</p>
      <div class="mt-3">
        <vs-button color="success" class="float-right" @click="isTaskBlocked = false">Go to Dashboard</vs-button>
      </div>
    </vs-popup>

    <vs-popup title="Time Capture" :active.sync="videoQuizTaskTimeCapturePopup">
      <div class="hoursUsed mb-8 mt-4">
        <p class="mb-2"> How many hours did you spend preparing for the assessment? </p>
            <vue-slider
              class="w-full mb-5"
              :tooltip="'none'"
              v-model="timeCaptureOnVideoQuizTask"
              :adsorb="true"
              :min="timeCapture.taskClassificationTypeId == 1 ? timeCapture.sliderMinFormatives : timeCapture.sliderMinSummatives"
              :max="timeCapture.taskClassificationTypeId == 1 ? timeCapture.sliderMaxFormatives : timeCapture.sliderMaxSummatives"
              :data-label="'id'"
              :data-value="'id'"
              :marks="true"
            ></vue-slider>
      </div>
      <div class="mt-3">
        <vs-button color="success" class="float-right" @click="videoQuizTaskTimeCapturePopup = false">Submit</vs-button>
      </div>
    </vs-popup>

    <b-modal
      id="video-quiz-question-popup"
      hide-backdrop
      centered
      ok-only
      scrollable
      no-close-on-backdrop
      content-class="shadow video-quiz-question-popup-width"
      title=""
      ok-title="Submit"
      @ok="submitAnswer"
      v-model="isQuestionPopupActive"
    >
      <div>
        <question-single-select
          v-if="videoQuiz.questions"
          :isCardActive="currentQuestionType == 1"
          :question="videoQuiz.questions[questionIndex]"
          :key="`${questionIndex}mcss`"
        />
        <question-multiple-select
          v-if="videoQuiz.questions"
          :isCardActive="currentQuestionType == 2"
          :key="`${questionIndex}mcms`"
          :question="videoQuiz.questions[questionIndex]"
          :isQuizJournal="true"
        />
        <question-free-text
          v-if="videoQuiz.questions"
          :isCardActive="currentQuestionType == 3"
          :question="videoQuiz.questions[questionIndex]"
        />
        <question-table
          v-if="videoQuiz.questions"
          :isCardActive="currentQuestionType == 4"
          :question="videoQuiz.questions[questionIndex]"
          @tableUpdated="tableUpdated"
          :key="`${questionIndex}table`"
        />
      </div>
    </b-modal>

    <vs-row vs-align="center" vs-type="flex" vs-justify="center" vs-w="12">
    </vs-row>
    <audio ref="audio" :src="currentScene.musicUrl" loop="true" autoplay="autoplay" />

    <vs-popup :active.sync="redoIspringPopup" :button-close-hidden="true" background-color="rgba(0,0,0,0.8)" title="Error">
      <h4>Oops! Something went wrong when we tried to submit your answers. Press <strong>'OK'</strong> to redo the quiz.</h4>
      <div class="vx-row">
        <div class="vx-col w-full">
          <vs-button class="mt-3 float-right" color="success" @click="redoIspringQuiz">OK</vs-button>
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<script>
  import vueFilePond, {setOptions } from 'vue-filepond';
  import FilePondPluginFileRename from 'filepond-plugin-file-rename';
  import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
  import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
  const FilePond = vueFilePond(FilePondPluginFileValidateType, FilePondPluginImagePreview,FilePondPluginFileRename);


  setOptions({
    fileRenameFunction: (file) => {
      var siteName = "Temp";
      if(localStorage.getItem('userSiteInfo') != ""){
        if(JSON.parse(localStorage.getItem('userSiteInfo')) instanceof Array)
          siteName = JSON.parse(localStorage.getItem('userSiteInfo'))[0].name;
        else 
          siteName = JSON.parse(localStorage.getItem('userSiteInfo')).name;
      }
        var randomString = Date.now();
        var dateObj = new Date();
        var year = dateObj.getUTCFullYear();
        var month = (dateObj.getUTCMonth() + 1).toString(); 
        var newBaseName = file.basename.replaceAll('#','');
        return siteName + "_Auto~StudentUpload~" + year + "_" +  "00".substring(0, 2 - month.length) + month + "~" + newBaseName + "_" + randomString + file.extension;
    }
  });


  import videojs from 'video.js';
  import streaming  from '@videojs/http-streaming'; 
  import 'quill/dist/quill.core.css';
  import 'quill/dist/quill.snow.css';
  import 'quill/dist/quill.bubble.css';
  import { quillEditor } from 'vue-quill-editor';
  import Player from '@vimeo/player'

  import Plyr from 'plyr';
  import 'plyr/dist/plyr.css';

  import { setTimeout, setInterval } from 'timers';
  import { uuid } from 'vue-uuid';
  import { WebCam } from 'vue-web-cam';

  import courseViewerQuiz from './CourseViewerQuiz.vue';

  import questionTable from "./QuestionTable.vue";
  import questionFreeText from "./QuestionFreeText.vue";
  import questionSingleSelect from "./QuestionSingleSelect.vue";
  import questionMultipleSelect from "./QuestionMultipleSelect.vue";

  import vSelect from 'vue-select'
  import VueSlider from 'vue-slider-component'
  import 'vue-slider-component/theme/antd.css'
  import pdf from 'vue-pdf'

  export default {
    name: "CourseViewer",
    components: {
      VueSlider,
      'v-select': vSelect,
      courseViewerQuiz,
      WebCam,
      quillEditor,
      Plyr,
      videojs,
      streaming,
      questionTable,
      questionFreeText,
      questionSingleSelect,
      questionMultipleSelect,
      pdf,
      FilePond
    },
    data() {
      return {
        types: [],
        redoIspringPopup: false,
        isTaskBlocked:false,
        isQuestionPopupActive: false,
        currentQuestionType: 0,
        questionIndex: -1,
        videoQuizResultData: {
          duration: 0,
          logIdentifier: "",
          quizId: 0,
          questions: []
        },
        isQuestionAnswered: false,
        editorOption: {
          modules: {
            toolbar: [
            ['bold', 'italic', 'underline', 'strike'],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
            [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
            [{ 'color': [] }, { 'background': [] }],
            ['clean']
          ]
          },
        },
        currentModuleId: "",
        backpackDocs: [],
        backpackNotes: [],
        backpackPopupActive: false,
        studentCoins: 0,
        courseViewerQuiz: false,
        quizResults: {},
        backgroundCardHeight: 0,
        backgroundCardWidth: 0,
        tasktypeId:0,
        dialog: {},
        scene: {},
        story: {},
        video: {},
        ispringquiz: {},
        presentation: {},
        document: {},
        upload: {},
        videoCapture: {},
        navigation: {},
        quiz: {},
        textNavigation: {},
        podcast: {},
        videoQuiz: {},
        podcastUrl: "",
        currentTask: -1,
        oldTaskIndex: -1,
        charHeight: 0,
        charTop: 0,
        regterkantsteKarakterSePosisieVanLinksAf: 0,
        textBoxTop: 0,
        textBoxLeft: 0,
        textBoxFontSize: 0,
        descriptionFontSize: 0,
        titleFontSize: 0,
        textResultVideoCapture: 0,
        textBoxEdges: 0,
        maxCardWidth: 1700,
        maxCardHeight: 0,
        showTextBox: false,
        currentDialogText: "",
        dialogOptions: [],
        textNavOptions: [],
        disableOverride: false,
        fileExt: "",
        source: "",
        queue: [],
        requestFormBuild: "",
        currentUserId: 0,
        currentSiteId: 0,
        logData: {},
        uuid: "",
        ispringQuizUrl: "",
        presentationUrl: "",
        documentUrl: "",
        videoCaptureUrl: "",
        allowedFileTypes: "",
        numItemsAllowed: 1,
        uploadedFiles: [],
        url: "",
        mapLocations: [],
        messageType: "",
        videoCaptureIframeUrl: "",
        isVideoLoading: false,
        isLoading: false,
        img: null,
        camera: null,
        deviceId: null,
        devices: [],
        frontCam: true,
        notesMode: "list",
        noteHeading: "",
        goHomeActive: false,
        noteData: {
          id: 0,
          studentId: 0,
          moduleId: 0,
          title: "",
          body: ""
        },
        i: 0,
        videoPlayer: null,
        podcastPlayer: null,
        vimeoPlayer: null,
        isNextTaskBtnHidden: true,
        vimeoVideoId: null,
        youtubeVideoId: null,
        isStartTask: "",
        isPreview: false,
        helpPopupActive: false,
        errorData: {
          taskId: null,
          userMessage: "",
          osName: "",
          osVersion: "",
          browserName: "",
          browserVersion: "",
          navigatorUserAgent: "",
          navigatorAppVersion: "",
          navigatorPlatform: "",
          navigatorVendor: "",
          isMobile: false,
          whatsappNumber: ""
        },
        currentTaskId: null,
        isTakingSnapshots: false,
        webcamStarted: false,
        snapshotInterval: null,
        dialogAudioUrl: "",
        videoTimeUpdateEvent: null,
        videoQuizCurrentTime: 0,
        videoQuizQuestionTimes: [],
        videoQuizPlayer: null,
        playerWasFullscreen: false,
        HoursDropDown:false,
        isBackAllowed: false,
        hoursDropdown:"",
        sliderData:[{name:"1-3",id:"1-3",number:1},
          {name:"4-6",id:"4-6",number:2},
          {name:"7-9",id:"7-9",number:3},
          {name:"10-12",id:"10-12",number:4},
          {name:"13-15",id:"13-15",number:5},
          {name:"16-18",id:"16-18",number:6},
          {name:"19-21",id:"19-21",number:7},
          {name:"22-24",id:"22-24",number:8},
          {name:"25-27",id:"25-27",number:9},
          {name:"28-30",id:"28-30",number:10}],
          
        slidervalue:'1-3',
        timeActive: false,
        showHomeButton: false,
        resetQuizButtons: false,
        src: "",
        numPages: undefined,
        loadedRatio: 0,
        page: 1,
        rotate: 0,
        isComplete: false,
        styleB: false,
        timeCapture: {
          captureTimeForAssessments: false,
		      formativeHoursRequired: null,
		      summativeHoursRequired: null,
          sliderMinFormatives: 0,
          sliderMaxFormatives: 0,
          sliderMinSummatives: 0,
          sliderMaxSummatives: 0,
          taskClassificationTypeId: 0,
        },
        timeCaptureOnUploadTask: null,
        timeCaptureOnVideoCaptureTask: null,
        timeCaptureOnVideoQuizTask: null,
        videoQuizTaskTimeCapturePopup: false,
        backArrowClicked: false,
        videoQuizPrevTaskIndex: 0,
        videoQuizBackDisplayId: "",
        zoomLevel: 100,
        rewrite:false,
      };
    },
    watch: {
      videoQuizCurrentTime: function(val) {
        var self = this;

        var minutes = ~~((val % 3600) / 60);
        var seconds = ~~val % 60;
        var finalTime = self.prettyPrintTime(minutes, '0', 2) + ':' + self.prettyPrintTime(seconds, '0', 2);

        if (self.videoQuizQuestionTimes.length > 0) {
          if (self.videoQuizQuestionTimes.includes(val)) {
            // self.videoQuizQuestionTimes = self.videoQuizQuestionTimes.remove(val);
            
            if (self.videoQuizPlayer)  {
              self.videoQuizPlayer.pause();
              if(self.videoQuizPlayer.isFullscreen()){
                self.playerWasFullscreen = true;
                self.videoQuizPlayer.exitFullscreen();
              }
              self.isQuestionPopupActive = true;
              var currentQuestion = self.videoQuiz.questions.filter(x => { return x.time == finalTime })[0];
              if(currentQuestion){
                self.questionIndex = currentQuestion.questionIndex;
                self.currentQuestionType = currentQuestion.quizQuestionTypeId;
              }
              else{
                self.isQuestionPopupActive = false;
                self.videoQuizPlayer.play();;
              }
              
            }
          }
        }
      },
      camera: function (id) {
        this.deviceId = id;
      },
      isTaskBlocked: function(){
        var self = this;
        if(!self.isTaskBlocked)
        {
          self.backToStudentMenu();
        }
      },
      videoQuizTaskTimeCapturePopup: function(){
        var self = this;
        if(!self.videoQuizTaskTimeCapturePopup)
        {
          if (self.videoQuizPlayer)  {
            self.videoQuizPlayer.pause();
            if(self.videoQuizPlayer.isFullscreen()){
              self.playerWasFullscreen = true;
              self.videoQuizPlayer.exitFullscreen();
            }
          }

          self.endVideoQuizTaskCourseTaskLog();
        }
      },
      devices: function () {
        if (typeof window.orientation === 'undefined') {
          let first = this.devices[0];
          if (first) {
            this.camera = first.deviceId;
            this.deviceId = first.deviceId;
          }
        } else {
          this.frontCam = false;
        }
      },
      currentTask: function () {
        var self = this;
        self.currentTaskId = self.story.tasks[self.currentTask].id; 
        self.timeCapture.taskClassificationTypeId = self.story.tasks[self.currentTask].taskClassificationTypeId;
        self.courseViewerQuiz = false;
        self.presentationUrl = "";
        self.ispringQuizUrl = "";
        self.documentUrl = "";
        self.videoCaptureUrl = "";
        self.url = "";
        self.podcastUrl = "";
        self.dialogAudioUrl = "";
        self.timeCaptureOnUploadTask = null;
        self.timeCaptureOnVideoCaptureTask = null;
        self.timeCaptureOnVideoQuizTask = null;
        self.page = 1;
        self.clearIFrameStorage();
        var isStudent = localStorage.getItem('isStudent');
        if (self.isDialogTask) {
          self.uuid = self.$uuid.v4();
          self.logData.taskId = self.story.tasks[self.currentTask].id;
          self.logData.logIdentifier = self.uuid;
          self.logData.fromTaskId = (self.oldTaskIndex == -1 ? null : self.story.tasks[self.oldTaskIndex].id);

          self.logData.percentLeft = self.story.storyPercentageRem;
          self.logData.daysLeft = self.story.storyDaysRem;
          self.enqueue("DialogTask/StartLogEntry", self.logData);
          
          var dailogTaskFunction = function(){
            self.$refs.audio.volume = 0.1;
            self.video = {};
            self.ispringquiz = {};
            self.presentation = {};
            self.document = {};
            self.upload = {};
            self.videoCapture = {};
            self.videoCaptureIframeUrl = "";
            self.navigation = {};
            self.quiz = {};
            self.textNavigation = {};
            self.podcast = {};
            self.videoQuiz = {};
            var character = {};
            var dialog = self.story.tasks[self.currentTask].dialogTask;
            if (dialog.text) {
              self.showTextBox = false;
              character.text = dialog.text;
              setTimeout(function () {
                self.showTextBox = true;
                character.look = self.story.characterLooks.filter(function (item) {
                  return item.id == dialog.characterLookId;
                })[0];

                if (self.currentCharacterLeft && self.currentCharacterLeft.text && Object.keys(self.currentCharacterLeft.text).length !== 0 && self.currentCharacterLeft.text != "")
                  self.currentDialogText = self.currentCharacterLeft.text;
                else if (self.currentCharacterRight && self.currentCharacterRight.text && Object.keys(self.currentCharacterRight.text).length !== 0 && self.currentCharacterRight.text != "")
                  self.currentDialogText = self.currentCharacterRight.text;
                else if (self.currentCharacterNone && self.currentCharacterNone.text && Object.keys(self.currentCharacterNone.text).length !== 0 && self.currentCharacterNone.text != "")
                  self.currentDialogText = self.currentCharacterNone.text;

                self.dialogOptions = [];
                if (dialog.options.length > 0) {
                  var options = dialog.options;
                  options.forEach(function (value) {
                    var nextTaskId = self.story.tasks.map(function (e) { return e.id; }).indexOf(value.nextTaskId);
                    self.dialogOptions.push({ taskId: nextTaskId, text: value.text, displayId: value.goTo });
                  });
                }
                self.dialogAudioUrl = dialog.audioUrl;
                //self.speak(character.look.voiceName, character.look.voiceTempo, character.text);
              }, 500);
            } 
          }

          var taskClassificationTypeId = self.story.tasks[self.currentTask].taskClassificationTypeId;
          if(taskClassificationTypeId == 2 && isStudent.toLowerCase() == "true")
          {
            var studentId = localStorage.getItem("Current_User_Id");
            var onSuccess = function(response){
              if(response.data == 2 || response.data == 1)
              {
                self.isTaskBlocked = true;
                return;
                
              }else
              {
                dailogTaskFunction();
                
              }
            } 
            self.$ajaxGet(self, "StudentModule/GetStudentModuleStatusId?studentId=" + studentId + "&moduleId=" + self.currentModuleId, onSuccess)
          }else
            dailogTaskFunction();
        } else if (self.isVideoTask) {
          if(self.isStartTask == "true") {
            self.isStartTask = "false";
            var adTaskBefore = self.story.tasks.filter(function(item){
              return item.videoTask && item.videoTask.ad && item.videoTask.goTo == self.story.tasks[self.currentTask].displayId
            })[0]

            if(adTaskBefore) {
              self.currentTask = self.story.tasks.map(function(item){
                return item.displayId;
              }).indexOf(adTaskBefore.displayId);
              adTaskBefore = null;
              return;
            }
          }
          self.uuid = self.$uuid.v4();
          self.logData.taskId = self.story.tasks[self.currentTask].id;
          self.logData.logIdentifier = self.uuid;
          self.logData.fromTaskId = (self.oldTaskIndex == -1 ? null : self.story.tasks[self.oldTaskIndex].id);

          self.logData.percentLeft = self.story.storyPercentageRem;
          self.logData.daysLeft = self.story.storyDaysRem;
          
          var videoTaskFunction = function(){
            self.ispringquiz = {};
            self.presentation = {};
            self.document = {};
            self.upload = {};
            self.videoCapture = {};
            self.videoCaptureIframeUrl = "";
            self.navigation = {};
            self.dialog = {};
            self.quiz = {};
            self.textNavigation = {};
            self.podcast = {};
            self.videoQuiz = {};
            self.$refs.audio.volume = 0.2;
            self.video = self.story.tasks[self.currentTask].videoTask;
            if(!self.video.ad)
              self.enqueue("VideoTask/StartLogEntry", self.logData);

            self.showTextBox = false;
            if (self.video.sceneId) {
              if (self.video.duration > 0) {
                var duration = self.video.duration * 1000;
                self.disableOverride = false;
                setTimeout(function () {
                  self.nextTask();
                  self.disableOverride = true;
                }, duration);
              }
            } else if (self.video.videoId) {
              self.currentScene.imageUrl = "";
              self.currentScene.musicUrl = "";

              if(self.video.allowSkip)
                self.isNextTaskBtnHidden = false;
              else
                self.isNextTaskBtnHidden = true;

              if (self.video.videoUrl) {
                var videoUrl = self.video.videoUrl;
                if (videoUrl.includes('m3u8')) {
                  var searchMask = "/index.m3u8";
                  var regEx = new RegExp(searchMask, "ig");
                  var replaceMask = ".mp4";

                  var oldVideoElement = document.getElementById("m3u8-player");
                  if (oldVideoElement) {
                    oldVideoElement.remove();
                  }
                  var videoContainerDiv = document.getElementById("videojs-container");
                  var videoElement = document.createElement('video');
                  videoElement.id = "m3u8-player";
                  videoElement.classList.add('video-js');
                  videoElement.classList.add('quiz-player');
                  videoElement.setAttribute('autoplay', true);
                  videoElement.setAttribute('controls', true);
                  videoContainerDiv.appendChild(videoElement);

                  var videoElement = document.getElementById("m3u8-player");

                  var player = videojs(videoElement);

                  player.on('error', function() {  
                  if(!videoUrl.includes("stream.digitv.co.za") && ( player.error().code == 2 || player.error().code == 4) && !videoUrl.includes(".mp4")){
							      setTimeout(function(){
						          videoUrl = videoUrl.replace(regEx, replaceMask);
							        player.src({ type: "video/mp4", src: videoUrl});
              				player.play();
                    },1000)

                  } else if (self.video.videoUrl.includes("stream.digitv.co.za") && ( player.error().code == 2 || player.error().code == 4)) {
                    alert("This live stream is not available at the moment")
                      setTimeout(function(){
                        player.src({ type: "application/x-mpegURL", src: videoUrl });
                        player.play();
                      },10000);					
                  }
                });

                  player.ready(function(){
                    this.on("ended", function(){ 
                      self.isNextTaskBtnHidden = false;
                    });
                  });

                  player.src({ type: "application/x-mpegURL", src: videoUrl });
                  player.play();
                  return;

                }

                if(self.video.videoTypeId == 1){

                  self.videoPlayer = new Plyr('#player', {
                    autoplay: true
                  });
                  self.showLoadingOnElement("videoPlayerCard", 1, "material");

                  var counter = 0;
                  self.videoPlayer.on('canplay', event => {
                    counter++;
                    if(counter == 2){
                      self.$vs.loading.close(self.$refs.videoPlayerCard.$el);
                    }
                  });

                  self.videoPlayer.on('ended', event => {
                    self.isNextTaskBtnHidden = false;
                  });

                  self.fileExt = videoUrl.substr(videoUrl.lastIndexOf(".") + 1);
                  self.source = [{ type: "video/" + self.fileExt, src: videoUrl }];
                  self.videoPlayer.source = {
                    type: 'video',
                    sources: self.source
                  };
                }
                else if(self.video.videoTypeId == 2){
                  self.vimeoVideoId = videoUrl.substr(videoUrl.lastIndexOf("/") + 1);
                  self.video.videoUrl = "https://player.vimeo.com/video/" + self.vimeoVideoId;

                  self.vimeoPlayer = new Player("videoFrame", {
                    id: self.vimeoVideoId,
                    width: self.backgroundCardWidth,
                    height: self.backgroundCardHeight,
                    autoplay: true,
                    muted: false,
                    gesture: 'media',
                    playsinline: true,
                    byline: false,
                    portrait: false,
                    title: false,
                    speed: true,
                    transparent: false,
                    sidedock: false,
                    controls: true,
                    referrerPolicy: null
                  });
                  self.vimeoPlayer.on('ended', event => {
                    self.isNextTaskBtnHidden = false;
                  });
                }
                else if(self.video.videoTypeId == 3){
                  self.youtubeVideoId = videoUrl.substr(videoUrl.lastIndexOf("/") + 1);
                  self.video.videoUrl = "https://www.youtube.com/embed/" + self.youtubeVideoId + "?autoplay=1"
                }
                else if(self.video.videoTypeId == 4){
                  self.video.videoUrl = videoUrl;
                  
                  if (!self.video.videoUrl.includes('m3u8')) {
                    self.videoPlayer = new Plyr('#externalPlayer', {
                      autoplay: true
                    });

                    self.videoPlayer.on('ended', event => {
                      self.isNextTaskBtnHidden = false;
                    });

                    self.fileExt = self.video.videoUrl.substr(self.video.videoUrl.lastIndexOf(".") + 1);
                    self.source = [{ type: "video/" + self.fileExt, src: self.video.videoUrl }];
                    self.videoPlayer.source = {
                      type: 'video',
                      sources: self.source
                    };
                  }
                }
              };
            };
          }

          var taskClassificationTypeId = self.story.tasks[self.currentTask].taskClassificationTypeId;
          if(taskClassificationTypeId == 2 && isStudent.toLowerCase() == "true")
          {
            var studentId = localStorage.getItem("Current_User_Id");
            var onSuccess = function(response){
              if(response.data == 2 || response.data == 1)
              {
                
                self.isTaskBlocked = true;
                return
              }else{
                videoTaskFunction();
              }
            } 
            self.$ajaxGet(self, "StudentModule/GetStudentModuleStatusId?studentId=" + studentId + "&moduleId=" + self.currentModuleId, onSuccess)
          }else
            videoTaskFunction();         
        } else if (self.isISpringQuizTask) {
          if(self.isMobile() && self.isISpringQuizTask.isDecisive){
            self.$vs.dialog({
              type: "confirm",
              color: 'warning',
              title: 'Mobile Device Detected',
              text: 'Unfortunately this quiz cannot be completed on a mobile device (smartphone or tablet).\n\nPlease log in again from a computer (laptop or desktop-computer).',
              accept: self.logoutStudent,
              cancel: self.mobilePromptCancelled,
              acceptText: "Log Out",
            })
            return;
          }

          if (!self.isMobile() && self.isISpringQuizTask.isDecisive) {
            self.webcamStarted = true;
          }
          self.displayOneTaskAttemptPopup();
          self.uuid = self.$uuid.v4();
          self.logData.taskId = self.story.tasks[self.currentTask].id;
          self.logData.logIdentifier = self.uuid;
          self.logData.fromTaskId = (self.oldTaskIndex == -1 ? null : self.story.tasks[self.oldTaskIndex].id);

          self.logData.percentLeft = self.story.storyPercentageRem;
          self.logData.daysLeft = self.story.storyDaysRem;

          self.enqueue("ISpringQuizTask/StartLogEntry", self.logData);

          var iSpringQuizTaskFunction = function(){
            self.ispringquiz = self.story.tasks[self.currentTask].iSpringQuizTask;
            self.ispringQuizUrl = self.ispringquiz.url + "?userid=" + self.currentUserId + "&siteid=" + self.currentSiteId + "&uniqueId=" + self.uuid;
            self.video = {};
            self.upload = {};
            self.videoCapture = {};
            self.videoCaptureIframeUrl = "";
            self.dialog = {};
            self.presentation = {};
            self.currentScene.imageUrl = "";
            self.currentScene.musicUrl = "";
            self.document = {};
            self.navigation = {};
            self.quiz = {};
            self.textNavigation = {};
            self.podcast = {};
            self.videoQuiz = {};            
          }

          var taskClassificationTypeId = self.story.tasks[self.currentTask].taskClassificationTypeId;
          if(taskClassificationTypeId == 2 && isStudent.toLowerCase() == "true")
          {
            var studentId = localStorage.getItem("Current_User_Id");
            var onSuccess = function(response){
              if(response.data == 2 || response.data == 1)
              {
                self.isTaskBlocked = true;
                return
              }else
              {
                iSpringQuizTaskFunction();
              }
            } 
            self.$ajaxGet(self, "StudentModule/GetStudentModuleStatusId?studentId=" + studentId + "&moduleId=" + self.currentModuleId, onSuccess)
          }else
            iSpringQuizTaskFunction();
        } else if (self.isPresentationTask) {
          self.uuid = self.$uuid.v4();
          self.logData.taskId = self.story.tasks[self.currentTask].id;
          self.logData.logIdentifier = self.uuid;
          self.logData.fromTaskId = (self.oldTaskIndex == -1 ? null : self.story.tasks[self.oldTaskIndex].id);

          self.logData.percentLeft = self.story.storyPercentageRem;
          self.logData.daysLeft = self.story.storyDaysRem;

          self.enqueue("PresentationTask/StartLogEntry", self.logData);

          var presentationTaskFunction = function(){
            self.ispringquiz = {};
            self.upload = {};
            self.videoCapture = {};
            self.videoCaptureIframeUrl = "";
            self.video = {};
            self.dialog = {};
            self.currentScene.imageUrl = "";
            self.currentScene.musicUrl = "";
            self.document = {};
            self.navigation = {};
            self.quiz = {};
            self.textNavigation = {};
            self.podcast = {};
            self.videoQuiz = {};

            self.presentation = self.story.tasks[self.currentTask].presentationTask;

            self.presentationUrl = self.presentation != null ? self.presentation.url.replaceAll("&amp;", "&") : "";
          }

          var taskClassificationTypeId = self.story.tasks[self.currentTask].taskClassificationTypeId;
          if(taskClassificationTypeId == 2 && isStudent.toLowerCase() == "true")
          {
            var studentId = localStorage.getItem("Current_User_Id");
            var onSuccess = function(response){
              if(response.data == 2 || response.data == 1)
              {
                self.isTaskBlocked = true;
                return
              }else{
                presentationTaskFunction();
                
              }
            } 
            self.$ajaxGet(self, "StudentModule/GetStudentModuleStatusId?studentId=" + studentId + "&moduleId=" + self.currentModuleId, onSuccess)
          }else
            presentationTaskFunction();
        } else if (self.isDocumentTask) {
          self.uuid = self.$uuid.v4();
          self.logData.taskId = self.story.tasks[self.currentTask].id;
          self.logData.logIdentifier = self.uuid;
          self.logData.fromTaskId = (self.oldTaskIndex == -1 ? null : self.story.tasks[self.oldTaskIndex].id);

          self.logData.percentLeft = self.story.storyPercentageRem;
          self.logData.daysLeft = self.story.storyDaysRem;

          self.enqueue("DocumentTask/StartLogEntry", self.logData);

          var documentTaskFunction = function(){
                self.ispringquiz = {};
                self.upload = {};
                self.video = {};
                self.navigation = {};
                self.dialog = {};
                self.videoCapture = {};
                self.videoCaptureIframeUrl = "";
                self.currentScene.imageUrl = "";
                self.currentScene.musicUrl = "";
                self.presentation = {};
                self.quiz = {};
                self.textNavigation = {};
                self.podcast = {};
                self.videoQuiz = {};

                self.document = self.story.tasks[self.currentTask].documentTask;

                self.documentUrl = self.document != null ? self.document.url : "";

                if (self.document.scrollable) {
                  var loadingTask = pdf.createLoadingTask(self.documentUrl);

                  loadingTask.promise.then(pdf => {

                    self.numPages = pdf.numPages;
                  });
                }
          }

          var taskClassificationTypeId = self.story.tasks[self.currentTask].taskClassificationTypeId;
          if(taskClassificationTypeId == 2 && isStudent.toLowerCase() == "true")
          {
            var studentId = localStorage.getItem("Current_User_Id");
            var onSuccess = function(response){
              if(response.data == 2 || response.data == 1)
              {
                self.isTaskBlocked = true;
                return
              }else{
                documentTaskFunction();
              }
            } 
            self.$ajaxGet(self, "StudentModule/GetStudentModuleStatusId?studentId=" + studentId + "&moduleId=" + self.currentModuleId, onSuccess)
          }else
            documentTaskFunction();
        } else if (self.isUploadTask) {
          self.logData.uploadedFiles = [];
          self.uploadedFiles = [];
          self.slidervalue = null;
          self.uuid = self.$uuid.v4();
          self.logData.taskId = self.story.tasks[self.currentTask].id;
          self.logData.logIdentifier = self.uuid;
          self.logData.fromTaskId = (self.oldTaskIndex == -1 ? null : self.story.tasks[self.oldTaskIndex].id);

          self.logData.percentLeft = self.story.storyPercentageRem;
          self.logData.daysLeft = self.story.storyDaysRem;
          self.displayOneTaskAttemptPopup();

          self.enqueue("UploadTask/StartLogEntry", self.logData);

          var uploadTaskFunction = function(){
            self.upload = self.story.tasks[self.currentTask].uploadTask;

            if (self.upload.allowMultiple)
              self.numItemsAllowed = 15;
            else
              self.numItemsAllowed = 1;

            if(self.upload){
            if (self.upload.allowAudio)
              self.types.push("audio/mp3");
            if (self.upload.allowDocument)
              self.types.push("application/pdf","application/msword", "application/vnd.ms-excel", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", "application/vnd.openxmlformats-officedocument.wordprocessingml.document", "text/plain","text/html","application/msaccess","application/vnd.ms-powerpoint","application/vnd.openxmlformats-officedocument.presentationml.presentation");
            if (self.upload.allowImage)
              self.types.push("image/png", "image/jpg", "image/jpeg", "image/gif");
            if (self.upload.allowVideo)
              self.types.push("video/mp4", "video/mov", "video/wmv");
          }

          self.types = self.types;

            self.ispringquiz = {};
            self.video = {};
            self.dialog = {};
            self.videoCapture = {};
            self.videoCaptureIframeUrl = "";
            self.document = {};
            self.navigation = {};
            self.currentScene.imageUrl = "";
            self.currentScene.musicUrl = "";
            self.presentation = {};
            self.quiz = {};
            self.textNavigation = {};
            self.podcast = {};
            self.videoQuiz = {};          
          }

          var taskClassificationTypeId = self.story.tasks[self.currentTask].taskClassificationTypeId;
          if(taskClassificationTypeId == 2 && isStudent.toLowerCase() == "true")
          {
            var studentId = localStorage.getItem("Current_User_Id");
            var onSuccess = function(response){
              if(response.data == 2 || response.data == 1)
              {
                self.isTaskBlocked = true;
                return
              }else{
                uploadTaskFunction();
              }
            } 
            self.$ajaxGet(self, "StudentModule/GetStudentModuleStatusId?studentId=" + studentId + "&moduleId=" + self.currentModuleId, onSuccess)
          }else
            uploadTaskFunction();
        } else if (self.isNavigationTask) {
          self.mapLocations = "";
          self.uuid = self.$uuid.v4();
          self.logData.taskId = self.story.tasks[self.currentTask].id;
          self.logData.logIdentifier = self.uuid;
          self.logData.fromTaskId = (self.oldTaskIndex == -1 ? null : self.story.tasks[self.oldTaskIndex].id);

          self.logData.percentLeft = self.story.storyPercentageRem;
          self.logData.daysLeft = self.story.storyDaysRem;

          self.enqueue("NavigationTask/StartLogEntry", self.logData);

          var navigationTaskFunction = function(){
            self.upload = {};
            self.videoCapture = {};
            self.videoCaptureIframeUrl = "";
            self.ispringquiz = {};
            self.video = {};
            self.dialog = {};
            self.document = {};
            self.presentation = {};
            self.quiz = {};
            self.textNavigation = {};
            self.podcast = {};
            self.videoQuiz = {};
            self.navigation = self.story.tasks[self.currentTask].navigationTask;
            self.$refs.audio.volume = 0.2;
            self.plotPoints();        
          }

          var taskClassificationTypeId = self.story.tasks[self.currentTask].taskClassificationTypeId;
          if(taskClassificationTypeId == 2 && isStudent.toLowerCase() == "true")
          {
            var studentId = localStorage.getItem("Current_User_Id");
            var onSuccess = function(response){
              if(response.data == 2 || response.data == 1)
              {
                self.isTaskBlocked = true;
                
              }else
              {
                navigationTaskFunction();
                return
              }
            } 
            self.$ajaxGet(self, "StudentModule/GetStudentModuleStatusId?studentId=" + studentId + "&moduleId=" + self.currentModuleId, onSuccess)
          }else
            navigationTaskFunction();
        } else if (self.isVideoCaptureTask) {
          self.videoCaptureType = "";
          self.logData.videoCaptureUrl = "";
          self.uuid = self.$uuid.v4();
          self.logData.taskId = self.story.tasks[self.currentTask].id;
          self.logData.logIdentifier = self.uuid;
          self.logData.fromTaskId = (self.oldTaskIndex == -1 ? null : self.story.tasks[self.oldTaskIndex].id);

          self.logData.percentLeft = self.story.storyPercentageRem;
          self.logData.daysLeft = self.story.storyDaysRem;
          self.displayOneTaskAttemptPopup();
          self.enqueue("VideoCaptureTask/StartLogEntry", self.logData);
          self.videoCapture = self.story.tasks[self.currentTask].videoCaptureTask;

          var videoCaptureTaskFunction = function(){
            self.videoCaptureIframeUrl = self.$VUE_APP_VIDEO_CAPTURE_URL + "&t=" + new Date().getTime();
            self.ispringquiz = {};
            self.upload = {};
            self.video = {};
            self.dialog = {};
            self.document = {};
            self.navigation = {};
            self.currentScene.imageUrl = "";
            self.currentScene.musicUrl = "";
            self.presentation = {};
            self.quiz = {};
            self.textNavigation = {};
            self.podcast = {};
            self.videoQuiz = {};
          }

          var taskClassificationTypeId = self.story.tasks[self.currentTask].taskClassificationTypeId;
          if(taskClassificationTypeId == 2 && isStudent.toLowerCase() == "true")
          {
            var studentId = localStorage.getItem("Current_User_Id");
            var onSuccess = function(response){
              if(response.data == 2 || response.data == 1)
              {
                self.isTaskBlocked = true;
              }else
              {
                videoCaptureTaskFunction();
                return
              }
            } 
            self.$ajaxGet(self, "StudentModule/GetStudentModuleStatusId?studentId=" + studentId + "&moduleId=" + self.currentModuleId, onSuccess)
          }else
              videoCaptureTaskFunction();
        } else if (self.isQuizTask) {
          self.tasktypeId = 9;

          self.$store.dispatch("updateTheme", "light");
          //Check if on mobile
          if(self.isMobile() && self.isQuizTask.isDecisive){
            self.$vs.dialog({
              type: "confirm",
              color: 'warning',
              title: 'Mobile Device Detected',
              text: 'Unfortunately this quiz cannot be completed on a mobile device (smartphone or tablet).\n\nPlease log in again from a computer (laptop or desktop-computer).',
              accept: self.logoutStudent,
              cancel: self.mobilePromptCancelled,
              acceptText: "Log Out",
            })
            return;
          }

          if (!self.isMobile() && self.isQuizTask.isDecisive) {
            self.webcamStarted = true;
          }

          //Continue
          self.disableOverride = false;

          self.video = {};
          self.upload = {};
          self.videoCapture = {};
          self.videoCaptureIframeUrl = "";
          self.dialog = {};
          self.presentation = {};
          self.currentScene.imageUrl = "";
          self.currentScene.musicUrl = "";
          self.document = {};
          self.navigation = {};
          self.ispringquiz = {};
          self.quizResults = {};
          self.textNavigation = {};
          self.podcast = {};
          self.videoQuiz = {};
          self.quiz = self.story.tasks[self.currentTask].quizTask;

          self.uuid = self.$uuid.v4();
          self.logData.taskId = self.story.tasks[self.currentTask].id;
          self.logData.logIdentifier = self.uuid;
          self.logData.fromTaskId = (self.oldTaskIndex == -1 ? null : self.story.tasks[self.oldTaskIndex].id);

          self.logData.percentLeft = self.story.storyPercentageRem;
          self.logData.daysLeft = self.story.storyDaysRem;
          
          var taskClassificationTypeId = self.story.tasks[self.currentTask].taskClassificationTypeId;
          if(taskClassificationTypeId == 2 && isStudent.toLowerCase() == "true")
          {
            var studentId = localStorage.getItem("Current_User_Id");
            var onSuccess = function(response){
              if(response.data == 2 || response.data == 1)
              {
                self.isTaskBlocked = true;
                
              }else{
                self.courseViewerQuiz = true;
                return;
              }        
              //show quiz component
              
            } 
            self.$ajaxGet(self, "StudentModule/GetStudentModuleStatusId?studentId=" + studentId + "&moduleId=" + self.currentModuleId, onSuccess)
          }else
            //show quiz component
            self.courseViewerQuiz = true;
        } else if (self.isTextNavigationTask) {
          self.uuid = self.$uuid.v4();
          self.logData.taskId = self.story.tasks[self.currentTask].id;
          self.logData.logIdentifier = self.uuid;
          self.logData.fromTaskId = (self.oldTaskIndex == -1 ? null : self.story.tasks[self.oldTaskIndex].id);

          self.logData.percentLeft = self.story.storyPercentageRem;
          self.logData.daysLeft = self.story.storyDaysRem;

          self.enqueue("TextNavigationTask/StartLogEntry", self.logData);

          var textNavigationTaskFunction = function(){
            self.upload = {};
            self.videoCapture = {};
            self.videoCaptureIframeUrl = "";
            self.ispringquiz = {};
            self.video = {};
            self.dialog = {};
            self.currentScene.musicUrl = "";
            self.document = {};
            self.presentation = {};
            self.quiz = {};
            self.navigation = {};
            self.podcast = {};
            self.videoQuiz = {};
            self.textNavigation = self.story.tasks[self.currentTask].textNavigationTask;

            self.textNavOptions = [];
            if (self.textNavigation.options.length > 0) {
              var options = self.textNavigation.options;
              options.forEach(function (value) {
                var nextTaskId = self.story.tasks.map(function (e) { return e.id; }).indexOf(value.nextTaskId);
                self.textNavOptions.push({ taskId: nextTaskId, text: value.text, displayId: value.goTo });
              });
            }

            self.$refs.audio.volume = 0.2;
          }

          var taskClassificationTypeId = self.story.tasks[self.currentTask].taskClassificationTypeId;
          if(taskClassificationTypeId == 2 && isStudent.toLowerCase() == "true")
          {
            var studentId = localStorage.getItem("Current_User_Id");
            var onSuccess = function(response){
              if(response.data == 2 || response.data == 1)
              {
                self.isTaskBlocked = true;
                return
              }else
              {
                textNavigationTaskFunction();
                
              }
              } 
              self.$ajaxGet(self, "StudentModule/GetStudentModuleStatusId?studentId=" + studentId + "&moduleId=" + self.currentModuleId, onSuccess)
          }else
            textNavigationTaskFunction();
        } else if (self.isPodcastTask) {

          if(self.story.backActive)
            self.isBackAllowed = true;
          else
            self.isBackAllowed = false;

          self.uuid = self.$uuid.v4();
          self.logData.taskId = self.story.tasks[self.currentTask].id;
          self.logData.logIdentifier = self.uuid;
          self.logData.fromTaskId = (self.oldTaskIndex == -1 ? null : self.story.tasks[self.oldTaskIndex].id);

          self.logData.percentLeft = self.story.storyPercentageRem;
          self.logData.daysLeft = self.story.storyDaysRem;

          self.enqueue("PodcastTask/StartLogEntry", self.logData);

          var podcastTaskFunction = function(){
            self.video = {};
            self.ispringquiz = {};
            self.presentation = {};
            self.document = {};
            self.upload = {};
            self.videoCapture = {};
            self.videoCaptureIframeUrl = "";
            self.navigation = {};
            self.dialog = {};
            self.quiz = {};
            self.textNavigation = {};
            self.$refs.audio.volume = 0.2;
            self.podcast = self.story.tasks[self.currentTask].podcastTask;
            self.showTextBox = false;          
            
            if (self.podcast.podcastUrl) {
              var podcastUrl = self.podcast.podcastUrl;
              self.podcastPlayer = new Plyr('#podcastPlayer', {
              autoplay: true
              });
              self.showLoadingOnElement("podcastPlayerCard", 1, "material");

              var counter = 0;
              self.podcastPlayer.on('canplay', event => {
                counter++;
                if(counter == 2){
                  self.$vs.loading.close(self.$refs.podcastPlayerCard.$el);
                }
              });
              self.isNextTaskBtnHidden = false;

              // self.podcastPlayer.on('ended', event => {
              //   self.isNextTaskBtnHidden = false;
              // });

              self.fileExt = podcastUrl.substr(podcastUrl.lastIndexOf(".") + 1);
              self.source = [{ type: "audio/" + self.fileExt, src: podcastUrl }];
              self.podcastPlayer.source = {
                type: 'audio',
                sources: self.source
              };
            };
          }

          var taskClassificationTypeId = self.story.tasks[self.currentTask].taskClassificationTypeId;
          if(taskClassificationTypeId == 2 && isStudent.toLowerCase() == "true")
          {
            var studentId = localStorage.getItem("Current_User_Id");
            var onSuccess = function(response){
              if(response.data == 2 || response.data == 1)
              {
                self.isTaskBlocked = true;
                return
              }
              else{
                podcastTaskFunction();
                
              }
            } 
            self.$ajaxGet(self, "StudentModule/GetStudentModuleStatusId?studentId=" + studentId + "&moduleId=" + self.currentModuleId, onSuccess)
          }else
            podcastTaskFunction();

        } else if (self.isVideoQuizTask) {
          self.isNextTaskBtnHidden = true;
          self.uuid = self.$uuid.v4();
          self.logData.taskId = self.story.tasks[self.currentTask].id;
          self.logData.logIdentifier = self.uuid;
          self.logData.fromTaskId = (self.oldTaskIndex == -1 ? null : self.story.tasks[self.oldTaskIndex].id);

          self.logData.percentLeft = self.story.storyPercentageRem;
          self.logData.daysLeft = self.story.storyDaysRem;
          self.logData.quizId = self.story.tasks[self.currentTask].videoQuizTask.quizId;
          self.displayOneTaskAttemptPopup();
          var isVideoQuizTaskFunction = function(){
            self.video = {};
            self.ispringquiz = {};
            self.presentation = {};
            self.document = {};
            self.upload = {};
            self.videoCapture = {};
            self.videoCaptureIframeUrl = "";
            self.navigation = {};
            self.dialog = {};
            self.quiz = {};
            self.textNavigation = {};
            self.podcast = {};
            self.tasktypeId = 14;

            self.videoQuiz = self.story.tasks[self.currentTask].videoQuizTask;

            self.showLoadingOnElement("whole_page", 1, "material");

            var onSuccess = response => {
              self.videoQuiz.questions = response.data.questions;
              self.videoQuiz.showRetryOption = response.data.showRetryOption;
              self.videoQuiz.showContinueOption = response.data.showContinueOption;
              self.videoQuiz.showStartOption = response.data.showStartOption;
              self.videoQuiz.logId = response.data.logId;
              self.logData.logIdentifier = response.data.logIdentifier;
              self.videoQuiz.logIdentifier = response.data.logIdentifier;
              self.videoQuiz.startedOn = response.data.startTime;

              if (self.quiz.showContinueOption) {
                self.continueTimer();
              }

              self.videoQuizQuestionTimes = [];
              var timeStrings = self.videoQuiz.questions.map(x => { return x.time });

              timeStrings.forEach(time => {
                var seconds = Number(time.split(':')[0]) * 60 + Number(time.split(':')[1]);
                self.videoQuizQuestionTimes.push(seconds);
              });

              var oldVideoElement = document.getElementById("quiz-m3u8-player");
              if (oldVideoElement) {
                oldVideoElement.remove();
              }
              var videoContainerDiv = document.getElementById("quiz-videojs-container");
              var videoElement = document.createElement('video');
              videoElement.id = "quiz-m3u8-player";
              videoElement.classList.add('video-js');
              videoElement.classList.add('quiz-player');
              videoElement.setAttribute('controls', true);
              videoContainerDiv.appendChild(videoElement);

              var videoElement = document.getElementById("quiz-m3u8-player");
              if (self.videoQuiz.videoUrl) {

                var videoUrl = self.videoQuiz.videoUrl;
                if (videoUrl.includes('m3u8')) {
                  var searchMask = "/index.m3u8";
                  var regEx = new RegExp(searchMask, "ig");
                  var replaceMask = ".mp4";
                  self.videoQuizPlayer = videojs(videoElement, { controlBar: { fullscreenToggle: true, pictureInPictureToggle: false } });

                  setTimeout(function(){
                    videoUrl = videoUrl.replace(regEx, replaceMask);
                    self.videoQuizPlayer.src({ type: "video/mp4", src: videoUrl});
                    self.videoQuizPlayer.play();
                  },1000)

                  self.videoQuizPlayer.ready(function(){
                    this.on("ended", function(){ 
                      self.isNextTaskBtnHidden = false;
                    });

                    this.on("fullscreenchange", function(){
                      if(self.videoQuizPlayer.isFullscreen()){
                        // self.videoQuizPlayer.exitFullscreen();
                        self.playerWasFullscreen = true;
                      }
                      else {
                        self.playerWasFullscreen = false;
                      }
                    });
                  });
                  var videoEL = document.getElementById("quiz-m3u8-player_html5_api");
                  self.videoTimeUpdateEvent = videoEL.addEventListener('timeupdate', function(e) {
                    self.videoQuizCurrentTime = Math.round(videoEL.currentTime,0);
                  }, false);
                  return;
                }
              }
            }   
            var onFinally = response => {
            self.$vs.loading.close(self.$refs.whole_page.$el);
            }
            self.$ajaxPost(self, "VideoQuizTask/StartLogEntry", self.logData, onSuccess, onFinally);  
          }
          var taskClassificationTypeId = self.story.tasks[self.currentTask].taskClassificationTypeId;
          if(taskClassificationTypeId == 2 && isStudent.toLowerCase() == "true")
          {
            var studentId = localStorage.getItem("Current_User_Id");
            var onSuccess = function(response){
              if(response.data == 2 || response.data == 1)
              {
                self.isTaskBlocked = true;
                return
              }else
              {
                isVideoQuizTaskFunction();
              }
            }
            self.$ajaxGet(self, "StudentModule/GetStudentModuleStatusId?studentId=" + studentId + "&moduleId=" + self.currentModuleId, onSuccess)
          }
          else
            isVideoQuizTaskFunction();
        }
      }
    },
    computed: {
      server(){
        return {
          url: 'https://content.digicampus.co.za/scripts/',
          process: {
            url: 'tue4VGmEsLhfsy43X8WBemZ5UnTzLDuD2.php',
          },
        };
      },
      uploadLocation: {
        get() {
          return this.$buildUrl("tempupload");
        }
      },
      device: function () {
        return find(this.devices, n => n.deviceId == this.deviceId);
      },
      isStudent: {
        get() {
          return this.$route.params.isStudent;
        }
      },
      isDisabled: function () {
        var self = this;
        if (!self.disableOverride) {
          if (self.currentTask != -1) {
            if (self.isDialogTask) {
              var dialog = self.story.tasks[self.currentTask].dialogTask;
              if (dialog.options.length != 0) {
                return true;
              }
            } else if (self.isVideoTask) {
              var video = self.story.tasks[self.currentTask].videoTask;

              if (video.videoUrl && !video.allowSkip) {
                return true;
              } else {
                return false;
              }

              if (video.duration)
                return true;
            } else if (self.isISpringQuizTask) {
              if (self.ispringquiz.quizResults) {
                if (self.ispringquiz.quizResults.completed)
                  return false;
              }
            } else if (self.isUploadTask) {
              self.timeActive = self.isUploadTask.timeActive;
              if (self.uploadedFiles.length == 0) {
                return true;
              } else return false;
            } else if (self.isVideoCaptureTask) {
              if (!self.videoCaptureUrl) {
                return true;
              } else return false;
            } else if (self.isQuizTask) {
              return true;
            } else if (self.isPodcastTask) {
              return false;
            }
          }
        }
      },
      currentScene: function () {
        var self = this;
        if (self.scene && self.scene.imageUrl) return self.scene;
        if (self.isDialogTask) {
          var sceneId = self.story.tasks[self.currentTask].dialogTask.sceneId;
          return self.story.scenes.filter(function (item) {
            return item.id == sceneId;
          })[0];
        } else if (self.isVideoTask) {
          var video = self.story.tasks[self.currentTask].videoTask;
          if (video.sceneId) {
            var sceneId = self.story.tasks[self.currentTask].videoTask.sceneId;
            return self.story.scenes.filter(function (item) {
              return item.id == sceneId;
            })[0];
          }
        } else if (self.isNavigationTask) {
          var sceneId = self.story.tasks[self.currentTask].navigationTask.sceneId;
          return self.story.scenes.filter(function (item) {
            return item.id == sceneId;
          })[0];
        } else if (self.isTextNavigationTask) {
          var sceneId = self.story.tasks[self.currentTask].textNavigationTask.sceneId;
          return self.story.scenes.filter(function (item) {
            return item.id == sceneId;
          })[0];
        }
        return {};
      },
      currentCharacterLeft: function () {
        var self = this;
        if (self.isDialogTask && self.story.tasks[self.currentTask].dialogTask.position == 1) {
          var character = {};
          var dialog = self.story.tasks[self.currentTask].dialogTask;
          character.text = dialog.text;
          character.look = self.story.characterLooks.filter(function (item) {
            return item.id == dialog.characterLookId;
          })[0];
          return character;
        } else return {
          look: {},
          text: {}
        };
      },
      currentCharacterRight: function () {
        var self = this;
        if (self.isDialogTask && self.story.tasks[self.currentTask].dialogTask.position == 2) {
          var character = {};
          var dialog = self.story.tasks[self.currentTask].dialogTask;
          character.text = dialog.text;
          character.look = self.story.characterLooks.filter(function (item) {
            return item.id == dialog.characterLookId;
          })[0];
          setTimeout(function () {
            self.resizeCard();
          }, 50)

          return character;
        } else return {
          look: {},
          text: {}
        };
      },
      currentCharacterNone: function () {
        var self = this;
        if (self.isDialogTask && self.story.tasks[self.currentTask].dialogTask.position == 3) {
          var character = {};
          var dialog = self.story.tasks[self.currentTask].dialogTask;
          character.text = dialog.text;
          character.look = {};
          return character;
        } else return {
          look: {},
          text: {}
        };
      },
      isDialogTask: function () {
        return this.story && this.story.tasks && this.story.tasks[this.currentTask] && this.story.tasks[this.currentTask].dialogTask;
      },
      isVideoTask: function () {
        return this.story && this.story.tasks && this.story.tasks[this.currentTask] && this.story.tasks[this.currentTask].videoTask;
      },
      isISpringQuizTask: function () {
        return this.story && this.story.tasks && this.story.tasks[this.currentTask] && this.story.tasks[this.currentTask].iSpringQuizTask;
      },
      isPresentationTask: function () {
        return this.story && this.story.tasks && this.story.tasks[this.currentTask] && this.story.tasks[this.currentTask].presentationTask;
      },
      isDocumentTask: function () {
        return this.story && this.story.tasks && this.story.tasks[this.currentTask] && this.story.tasks[this.currentTask].documentTask;
      },
      isUploadTask: function () {
        return this.story && this.story.tasks && this.story.tasks[this.currentTask] && this.story.tasks[this.currentTask].uploadTask;
      },
      isVideoCaptureTask: function () {
        return this.story && this.story.tasks && this.story.tasks[this.currentTask] && this.story.tasks[this.currentTask].videoCaptureTask;
      },
      isNavigationTask: function () {
        return this.story && this.story.tasks && this.story.tasks[this.currentTask] && this.story.tasks[this.currentTask].navigationTask;
      },
      isQuizTask: function () {
        return this.story && this.story.tasks && this.story.tasks[this.currentTask] && this.story.tasks[this.currentTask].quizTask;
      },
      isTextNavigationTask: function () {
        return this.story && this.story.tasks && this.story.tasks[this.currentTask] && this.story.tasks[this.currentTask].textNavigationTask;
      },
      isPodcastTask: function () {
        return this.story && this.story.tasks && this.story.tasks[this.currentTask] && this.story.tasks[this.currentTask].podcastTask;
      },
      isVideoQuizTask: function () {
        return this.story && this.story.tasks && this.story.tasks[this.currentTask] && this.story.tasks[this.currentTask].videoQuizTask;
      },
    },
    methods: {
      uploadComplete(error, file) {
        var self = this;
        var response = file.serverId;
        
        if(response)
          this.uploadedFiles.push(response);

        self.$vs.notify({
            title:'Information',
            color: "success",
            text: "New file Saved",
            position:'top-right',
            iconPack: 'feather',
            icon:'icon-video',
            });  
        this.isLoading = false;
      },
      fileRemoved(error, file) {
        this.formData.uploadedFileName = "";
      },
      findPrint(){
        this.$refs.pdf.print();
      },
      prettyPrintTime(string, pad, length) {
        return (new Array(length+1).join(pad)+string).slice(-length);
      },
      somethingInTable: function() {
        var self = this;
        return (
          self.videoQuiz.questions[self.questionIndex].rowValues.filter(
            x => Object.values(x).filter(y => y).length >= 3
          ).length > 0
        );
      },
      submitAnswer() {
        var self = this;
        self.logTempAnswer(self.questionIndex);
        self.videoQuizPlayer.play();

        if (self.playerWasFullscreen) {
          self.videoQuizPlayer.enterFullscreen();
          self.playerWasFullscreen = false;
        }
      },
      finishVideoQuiz() {
        var self = this;
        
        // self.logQuizFinished();
        self.videoQuizResultData.quizId = self.videoQuiz.quizId;
        self.videoQuizResultData.questions = self.videoQuiz.questions;
        self.videoQuizResultData.logIdentifier = self.logData.logIdentifier;

        self.$ajaxPost(self, "VideoQuizTask/LogResults", self.videoQuizResultData);
      },
      somethingChangedInTable() {
        var self = this;
        if (
          Object.keys(self.videoQuiz).length != 0 &&
          self.videoQuiz.questions.length > 0 &&
          self.questionIndex > -1
        ) {
          if (self.currentQuestionType == 1) {
            self.isQuestionAnswered = self.videoQuiz.questions[self.questionIndex].inputAnswer
              ? true
              : false;
          } else if (self.currentQuestionType == 2) {
            if (
              self.videoQuiz.questions[self.questionIndex].options.filter(function(item) {
                return item.isSelected;
              }).length > 0
            ) {
              self.isQuestionAnswered = true;
            } else {
              self.isQuestionAnswered = false;
            }
          } else if (self.currentQuestionType == 3) {
            self.isQuestionAnswered = self.videoQuiz.questions[self.questionIndex].inputAnswer
              ? true
              : false;
          } else if (self.currentQuestionType == 4) {
            self.isQuestionAnswered = self.somethingInTable();
          }
        }
      },
      tableUpdated() {
        this.somethingChangedInTable();
      },
      logTempAnswer(oldIndex) {
        var self = this;

        var currentQuestion = self.videoQuiz.questions[oldIndex];

        var tempData = {
          logIdentifier: self.logData.logIdentifier,
          questionId: currentQuestion.quizQuestionId,
          answers: []
        };

        if (
          currentQuestion.quizQuestionTypeId == 1 ||
          currentQuestion.quizQuestionTypeId == 3
        ) {
          //MultipleChoiceSingleAnswer || FreeText
          tempData.answers.push({ value: currentQuestion.inputAnswer });
        } else if (currentQuestion.quizQuestionTypeId == 2) {
          //MultipleChoiceMultipleAnswers
          currentQuestion.options.forEach(option => {
            if (option.isSelected) {
              tempData.answers.push({ value: option.id });
            }
          });
        } else if (currentQuestion.quizQuestionTypeId == 4) {
          //Table
          var rowValuesWithInputAnswers = currentQuestion.rowValues.filter(
            function(item) {
              return Object.keys(item).length > 2;
            }
          );
          rowValuesWithInputAnswers.forEach(row => {
            var rowObjectKeys = Object.keys(row);
            var colNames = rowObjectKeys.filter(function(item) {
              return item != "id" && item != "question";
            });
            colNames.forEach(colName => {
              var colId = currentQuestion.columnValues.filter(function(item) {
                return item.field == colName;
              })[0].id;
              var rowId = row.id;
              var inputAnswer = row[colName];

              tempData.answers.push({
                value: inputAnswer,
                quizQuestionColumnId: colId,
                quizQuestionRowId: rowId
              });
            });
          });
        }

        self.$ajaxPost(self, "VideoQuizTask/TempLogAnswer", tempData);
      },
      backToStudentMenu() {
        var self = this;
        setTimeout(function () {
          if(self.rewrite){
            self.$router.push('/menu');
            return;
          }
          if (self.$siteTypeId() == 1) {
            var selectedData = JSON.parse(localStorage.getItem("selectedData"));
            var isTeacher = localStorage.getItem("isTeacher");
            isTeacher = isTeacher == "true" ? true : false;
            if (isTeacher) {
              if (self.$route.query && self.$route.query.ref == "resources") {
                self.$router.push({ name: 'TeacherResources' });
              } else {
                self.$router.push({ name: 'TeacherBrowseContent', params: { selectedData: selectedData, navFromLesson: true } });
              }
            }
            else {
              if(!self.isTaskBlocked){
                if(self.isISpringQuizTask){
                  self.goHomeActive = true;
                }
                else{
                  if (self.$route.query && self.$route.query.ref == "resources") {
                    self.$router.push({ name: 'StudentAdditionalResources' });
                  } else {
                    self.$router.push({ name: 'BrowseContent', params: { selectedData: selectedData, navFromLesson: true } });
                  }
                }  
              }
              else{
                self.$router.push('/menu');
              }         
            } 
          }
          else {
            var timeCapture = null;
            if (self.$route.query.timeCapture) {
              timeCapture = JSON.parse(self.$route.query.timeCapture);
            }
            if(self.isTaskBlocked){
              if (self.$route.query && self.$route.query.ref == "sonke") {
                if (self.$route.query.moduleId) {
                  if (self.$route.query.outcome) {
                    self.$router.push({ name: "Gen2OutcomeTasks", query: { moduleId: self.$route.query.moduleId, lpName: self.$route.query.lpName, lpNumber: self.$route.query.lpNumber, selectedTaskGroup: self.$route.query.selectedTaskGroup, selectedOutcome: self.$route.query.selectedOutcome, timeCapture: JSON.stringify(timeCapture) }});
                  } else {
                    self.$router.push({ name: "Gen2LearningPrograms", query: { ref: "continue" }, params: { lp: {moduleId: self.$route.query.moduleId, moduleName: self.$route.query.lpName, number: self.$route.query.lpNumber}, selectedTaskGroup: self.$route.query.selectedTaskGroup }});
                  }
                } else {
                  self.$router.push({ name: "Gen2LearningPrograms", query: { ref: "continue" }});
                }
              } else if (self.$route.query && self.$route.query.ref == "public") {
                if (self.$route.query.moduleId) {
                  if (self.$route.query.outcome) {
                    self.$router.push({ name: "PublicOutcomeTasks", query: { moduleId: self.$route.query.moduleId, lpName: self.$route.query.lpName, lpNumber: self.$route.query.lpNumber, selectedTaskGroup: self.$route.query.selectedTaskGroup, selectedOutcome: self.$route.query.selectedOutcome, timeCapture: JSON.stringify(timeCapture) }});
                  } else {
                    self.$router.push({ name: "PublicStudentDashboard", query: { ref: "continue", id: self.$route.query.moduleId }, params: { lp: {moduleId: self.$route.query.moduleId, moduleName: self.$route.query.lpName, number: self.$route.query.lpNumber}, selectedTaskGroup: self.$route.query.selectedTaskGroup }});
                  }
                } else {
                  self.$router.push({ name: "PublicStudentDashboard", query: { ref: "continue" }});
                }
              } else {
                if(self.isISpringQuizTask){
                  self.goHomeActive = true;
                }
                else{
                  self.$router.push({ name: 'BrowseContent', params: { selectedData: selectedData, navFromLesson: true } });
                }
              }
            }
            else if((Object.keys(self.$route.params)!=0)){
              if (self.$route.query && self.$route.query.ref == "sonke") {
                if (self.$route.query.moduleId) {
                  if (self.$route.query.outcome) {
                    self.$router.push({ name: "Gen2OutcomeTasks", query: { moduleId: self.$route.query.moduleId, lpName: self.$route.query.lpName, lpNumber: self.$route.query.lpNumber, selectedTaskGroup: self.$route.query.selectedTaskGroup, selectedOutcome: self.$route.query.selectedOutcome, timeCapture: JSON.stringify(timeCapture) }});
                  } else {
                    self.$router.push({ name: "Gen2LearningPrograms", query: { ref: "continue" }, params: { lp: {moduleId: self.$route.query.moduleId, moduleName: self.$route.query.lpName, number: self.$route.query.lpNumber}, selectedTaskGroup: self.$route.query.selectedTaskGroup }});
                  }
                } else {
                  self.$router.push({ name: "Gen2LearningPrograms", query: { ref: "continue" }});
                }
              } else if (self.$route.query && self.$route.query.ref == "public") {
                if (self.$route.query.moduleId) {
                  if (self.$route.query.outcome) {
                    self.$router.push({ name: "PublicOutcomeTasks", query: { moduleId: self.$route.query.moduleId, lpName: self.$route.query.lpName, lpNumber: self.$route.query.lpNumber, selectedTaskGroup: self.$route.query.selectedTaskGroup, selectedOutcome: self.$route.query.selectedOutcome, timeCapture: JSON.stringify(timeCapture) }});
                  } else {
                    self.$router.push({ name: "PublicStudentDashboard", query: { ref: "continue", id: self.$route.query.moduleId }, params: { lp: {moduleId: self.$route.query.moduleId, moduleName: self.$route.query.lpName, number: self.$route.query.lpNumber}, selectedTaskGroup: self.$route.query.selectedTaskGroup }});
                  }
                } else {
                  self.$router.push({ name: "PublicStudentDashboard", query: { ref: "continue" }});
                }
              } else {
                if(self.$route.params.styleB) {
                  if (self.$route.params.outcome) {
                    self.$router.push({ name: 'Gen2OutcomeTasks', query: { moduleId: self.$route.params.moduleId, lpName: self.$route.query.lpName, lpNumber: self.$route.query.lpNumber, selectedTaskGroup: self.$route.query.selectedTaskGroup, timeCapture: JSON.stringify(timeCapture) }});
                  } else {
                    self.$router.push({ name: 'LearningStyleBViewer', params: { moduleId: self.$route.params.moduleId, checkTimeCapture: true }})
                  }
                }
                else{
                  self.$router.push('/menu');
                }
              }
            }
            else{
              if (self.$route.query && self.$route.query.ref == "sonke") {
                if (self.$route.query.moduleId) {
                  if (self.$route.query.outcome) {
                    self.$router.push({ name: "Gen2OutcomeTasks", query: { moduleId: self.$route.query.moduleId, lpName: self.$route.query.lpName, lpNumber: self.$route.query.lpNumber, selectedTaskGroup: self.$route.query.selectedTaskGroup, selectedOutcome: self.$route.query.selectedOutcome, timeCapture: JSON.stringify(timeCapture) }});
                  } else {
                    self.$router.push({ name: "Gen2LearningPrograms", query: { ref: "continue" }, params: { lp: {moduleId: self.$route.query.moduleId, moduleName: self.$route.query.lpName, number: self.$route.query.lpNumber}, selectedTaskGroup: self.$route.query.selectedTaskGroup }});
                  }
                } else {
                  self.$router.push({ name: "Gen2LearningPrograms", query: { ref: "continue" }});
                }
              } else if (self.$route.query && self.$route.query.ref == "public") {
                if (self.$route.query.moduleId) {
                  if (self.$route.query.outcome) {
                    self.$router.push({ name: "PublicOutcomeTasks", query: { moduleId: self.$route.query.moduleId, lpName: self.$route.query.lpName, lpNumber: self.$route.query.lpNumber, selectedTaskGroup: self.$route.query.selectedTaskGroup, selectedOutcome: self.$route.query.selectedOutcome, timeCapture: JSON.stringify(timeCapture) }});
                  } else {
                    self.$router.push({ name: "PublicStudentDashboard", query: { ref: "continue", id: self.$route.query.moduleId }, params: { lp: {moduleId: self.$route.query.moduleId, moduleName: self.$route.query.lpName, number: self.$route.query.lpNumber}, selectedTaskGroup: self.$route.query.selectedTaskGroup }});
                  }
                } else {
                  self.$router.push({ name: "PublicStudentDashboard", query: { ref: "continue" }});
                }
              } else
                self.$router.push('/menu');
            }          
          }
        }, 69)
      },
      confirmHome(){
        var self = this;
        self.goHomeActive = false;

        setTimeout(function() {
          var selectedData = JSON.parse(localStorage.getItem("selectedData"));
          
          if (self.$route.query && self.$route.query.ref == "sonke") {
            if (self.$route.query.moduleId) {
              var timeCapture = null;
              if (self.$route.query.timeCapture) {
                timeCapture = JSON.parse(self.$route.query.timeCapture);
              }
              if (self.$route.query.outcome) {
                self.$router.push({ name: "Gen2OutcomeTasks", query: { moduleId: self.$route.query.moduleId, lpName: self.$route.query.lpName, lpNumber: self.$route.query.lpNumber, selectedTaskGroup: self.$route.query.selectedTaskGroup, selectedOutcome: self.$route.query.selectedOutcome, timeCapture: JSON.stringify(timeCapture) }});
              } else {
                self.$router.push({ name: "Gen2LearningPrograms", query: { ref: "continue" }, params: { lp: {moduleId: self.$route.query.moduleId, moduleName: self.$route.query.lpName, number: self.$route.query.lpNumber}, selectedTaskGroup: self.$route.query.selectedTaskGroup }});
              }
            } else {
              self.$router.push({ name: "Gen2LearningPrograms", query: { ref: "continue" }});
            }
          } else if (self.$route.query && self.$route.query.ref == "public") {
            if (self.$route.query.moduleId) {
              var timeCapture = null;
              if (self.$route.query.timeCapture) {
                timeCapture = JSON.parse(self.$route.query.timeCapture);
              }
              if (self.$route.query.outcome) {
                self.$router.push({ name: "PublicOutcomeTasks", query: { moduleId: self.$route.query.moduleId, lpName: self.$route.query.lpName, lpNumber: self.$route.query.lpNumber, selectedTaskGroup: self.$route.query.selectedTaskGroup, selectedOutcome: self.$route.query.selectedOutcome, timeCapture: JSON.stringify(timeCapture) }});
              } else {
                self.$router.push({ name: "PublicStudentDashboard", query: { ref: "continue", id: self.$route.query.moduleId }, params: { lp: {moduleId: self.$route.query.moduleId, moduleName: self.$route.query.lpName, number: self.$route.query.lpNumber}, selectedTaskGroup: self.$route.query.selectedTaskGroup }});
              }
            } else {
              self.$router.push({ name: "PublicStudentDashboard", query: { ref: "continue" }});
            }
          } else
            self.$router.push({ name: 'BrowseContent', params: { selectedData: selectedData, navFromLesson: true } });
        }, 69);
      },
      hideHomeButton(){
        this.showHomeButton = false;
      },
      hideBackButton(){
        this.isBackAllowed = false;
      },
      showBackButton(){
        var self = this;
        if(self.story.backActive){
          self.isBackAllowed = true;
        }else{
          self.isBackAllowed = false;
        }
      },
      getBackTask(displayId){
        var previousDialogTasks = this.story.tasks.filter(x => x.dialogTask && (x.dialogTask.options.filter(y=>y.goTo == displayId).length > 0 || x.dialogTask.goTo == displayId));      
        var previousDocumentTasks = this.story.tasks.filter(x => x.documentTask && x.documentTask.goTo == displayId);
        var previousISpringQuizTasks = this.story.tasks.filter(x => x.iSpringQuizTask && (x.iSpringQuizTask.passTaskGoto == displayId || x.iSpringQuizTask.failTaskGoto == displayId));
        var previousNavigationTasks = this.story.tasks.filter(x => x.navigationTask && (x.navigationTask.locationOptions.filter(y=>y.goTo == displayId).length > 0 || x.navigationTask.goTo == displayId));
        var previousPodcastTasks = this.story.tasks.filter(x => x.podcastTask && x.podcastTask.goTo == displayId);
        var previousPresentationTasks = this.story.tasks.filter(x => x.presentationTask && x.presentationTask.goTo == displayId);
        var previousQuizTasks =  this.story.tasks.filter(x => x.quizTask && (x.quizTask.passTaskGoto == displayId || x.quizTask.failTaskGoto == displayId));
        var previousTextNavigationTasks = this.story.tasks.filter(x => x.textNavigationTask && (x.textNavigationTask.options.filter(y=>y.goTo == displayId).length > 0 || x.textNavigationTask.goTo == displayId));
        var previousUploadTasks = this.story.tasks.filter(x => x.uploadTask && x.uploadTask.goTo == displayId);
        var previousVideoCaptureTasks = this.story.tasks.filter(x => x.videoCaptureTask && x.videoCaptureTask.goTo == displayId);
        var previousVideoQuizTasks = this.story.tasks.filter(x => x.videoQuizTask && x.videoQuizTask.goTo == displayId);
        var previousVideoTasks =  this.story.tasks.filter(x => x.videoTask && x.videoTask.goTo == displayId);

        if(previousDialogTasks.length + previousDocumentTasks.length + previousISpringQuizTasks.length +
          previousNavigationTasks.length + previousPodcastTasks.length + previousPresentationTasks.length +
          previousQuizTasks.length + previousTextNavigationTasks.length + previousUploadTasks.length +
          previousVideoCaptureTasks.length + previousVideoQuizTasks.length + previousVideoTasks.length
          > 1){
          return -1;
        } else {
          if(previousDialogTasks.length > 0)
            return previousDialogTasks[0].displayId;

          if(previousVideoTasks.length > 0)
            return previousVideoTasks[0].displayId;    

          if(previousISpringQuizTasks.length > 0)
            return previousISpringQuizTasks[0].displayId;

          if(previousPresentationTasks.length > 0)
            return previousPresentationTasks[0].displayId; 

          if(previousDocumentTasks.length > 0)
            return previousDocumentTasks[0].displayId;

          if(previousUploadTasks.length > 0)
            return previousUploadTasks[0].displayId; 

          if(previousVideoCaptureTasks.length > 0)
            return previousVideoCaptureTasks[0].displayId;

          if(previousNavigationTasks.length > 0)
            return previousNavigationTasks[0].displayId; 

          if(previousQuizTasks.length > 0)
            return previousQuizTasks[0].displayId;

          if(previousTextNavigationTasks.length > 0)
            return previousTextNavigationTasks[0].displayId; 

          if(previousPodcastTasks.length > 0)
            return previousPodcastTasks[0].displayId; 

          if(previousVideoQuizTasks.length > 0)
            return previousVideoQuizTasks[0].displayId;    
        }
      },
      backToTask(){
        var self = this;
        
        self.backArrowClicked = true;
        var displayId = this.story.tasks[self.currentTask].displayId;
        var previousTaskDisplayId = self.getBackTask(displayId);

        if (self.currentTask != -1) {     
          if(previousTaskDisplayId != -1){
            var prevTaskindex = self.story.tasks.map(function (item) {
                return item.displayId;
              }).indexOf(previousTaskDisplayId);

            if (self.isDialogTask) {
              var dialog = self.story.tasks[self.currentTask].dialogTask;
              if (dialog.options.length == 0) {

                self.oldTaskIndex = self.currentTask;
                self.logData.fromTaskId = self.story.tasks[self.oldTaskIndex].id;

                if (prevTaskindex > -1) {
                  self.currentTask = prevTaskindex;
                  localStorage.setItem('lastTask', displayId)
                } else {
                  if (self.$route.params.isStudent)
                    self.backToStudentMenu();
                }

                self.logData.toTaskId = self.story.tasks[self.currentTask].id;

                self.enqueue("DialogTask/EndLogEntry", self.logData);
              }
            } else if (self.isVideoTask) {
              self.oldTaskIndex = self.currentTask;
              self.logData.fromTaskId = self.story.tasks[self.oldTaskIndex].id;

              if (prevTaskindex > -1) {
                self.currentTask = prevTaskindex;
                localStorage.setItem('lastTask', displayId)
              } else {
                if (self.$route.params.isStudent)
                  self.backToStudentMenu();
              }

              self.logData.toTaskId = self.story.tasks[self.currentTask].id;

              if(self.video && !self.video.ad)
                self.enqueue("VideoTask/EndLogEntry", self.logData);

              if(self.videoPlayer)
                self.videoPlayer.destroy();

              if(self.vimeoPlayer)
                self.vimeoPlayer.destroy();

              self.$refs.youtubePlayer.player.clearVideo();
              self.$refs.youtubePlayer.player.stopVideo();

              var oldVideoElement = document.getElementById("m3u8-player");
              if (oldVideoElement) {
                oldVideoElement.remove();
              }

            } else if (self.isISpringQuizTask) {
              self.oldTaskIndex = self.currentTask;
              self.logData.fromTaskId = self.story.tasks[self.oldTaskIndex].id;

              if (prevTaskindex > -1) {
                self.currentTask = prevTaskindex;
                localStorage.setItem('lastTask', displayId)
                //localStorage.setItem('lastTask', self.ispringquiz.quizResults.quizStatus == "Passed" || self.ispringquiz.quizResults.quizStatus == "Completed" ? self.ispringquiz.passTaskGoto : self.ispringquiz.failTaskGoto)
              } else {
                if (self.$route.params.isStudent)
                  self.backToStudentMenu();
              }

              self.logData.toTaskId = self.story.tasks[self.currentTask].id;
              self.enqueue("ISpringQuizTask/EndLogEntry", self.logData);
              
            } else if (self.isPresentationTask) {

              var styleB = false;
              self.oldTaskIndex = self.currentTask;
              self.logData.fromTaskId = self.story.tasks[self.oldTaskIndex].id;
              //If style B: Dont enque the Log
              if((Object.keys(self.$route.params)!=0)){
                if(self.$route.params.styleB)
                  styleB= true;
              }

              if(styleB){
                var onFinally = e => {
                  if (self.$route.params.isStudent)
                    self.backToStudentMenu();
                }

                var onSuccess = response =>{
                  
                }

                if (prevTaskindex > -1) {
                  self.currentTask = prevTaskindex;
                  localStorage.setItem('lastTask', displayId);
                }
                self.logData.toTaskId = self.story.tasks[self.currentTask].id;
                
                self.$ajaxPost(self, "PresentationTask/EndLogEntry" , self.logData , onSuccess, onFinally);
              }else{
                
                if (prevTaskindex > -1) {
                  self.currentTask = prevTaskindex;
                  localStorage.setItem('lastTask', displayId);
                } else {
                  if (self.$route.params.isStudent)
                    self.backToStudentMenu();
                }

                self.logData.toTaskId = self.story.tasks[self.currentTask].id;

                self.enqueue("PresentationTask/EndLogEntry", self.logData);
              }
              
            } else if (self.isDocumentTask) {
              self.oldTaskIndex = self.currentTask;
              self.logData.fromTaskId = self.story.tasks[self.oldTaskIndex].id;

              if (prevTaskindex > -1) {
                self.currentTask = prevTaskindex;
                localStorage.setItem('lastTask', displayId);
              } else {
                if (self.$route.params.isStudent)
                  self.backToStudentMenu();
              }

              self.logData.toTaskId = self.story.tasks[self.currentTask].id;

              self.enqueue("DocumentTask/EndLogEntry", self.logData);
            } else if (self.isUploadTask) {
              self.oldTaskIndex = self.currentTask;
              self.logData.fromTaskId = self.story.tasks[self.oldTaskIndex].id;
              self.logData.uploadedFiles = self.uploadedFiles;

              if (prevTaskindex > -1) {
                self.currentTask = prevTaskindex;
                localStorage.setItem('lastTask', displayId);
              } else {
                if (self.$route.params.isStudent)
                  self.backToStudentMenu();
              }

              self.logData.toTaskId = self.story.tasks[self.currentTask].id;
              self.logData.timeCapture = self.timeCapture.captureTimeForAssessments 
                ? (self.timeCaptureOnUploadTask == null 
                  ? (self.timeCapture.taskClassificationTypeId == 1 
                    ? self.timeCapture.sliderMinFormatives : self.timeCapture.sliderMinSummatives) : self.timeCaptureOnUploadTask) : null;

              self.enqueue("UploadTask/EndLogEntry", self.logData);
            } else if (self.isVideoCaptureTask) {
              self.messageType = "";
              
              self.oldTaskIndex = self.currentTask;
              self.logData.fromTaskId = self.story.tasks[self.oldTaskIndex].id;

              if (prevTaskindex > -1) {
                self.currentTask = prevTaskindex;
                localStorage.setItem('lastTask', displayId);
              } else {
                if (self.$route.params.isStudent)
                  self.backToStudentMenu();
              }

              self.logData.toTaskId = self.story.tasks[self.currentTask].id;
              self.logData.videoCaptureUrl = self.videoCaptureUrl;

              self.logData.timeCapture = self.timeCapture.captureTimeForAssessments 
                ? (self.timeCaptureOnVideoCaptureTask == null 
                  ? (self.timeCapture.taskClassificationTypeId == 1 
                    ? self.timeCapture.sliderMinFormatives : self.timeCapture.sliderMinSummatives) : self.timeCaptureOnVideoCaptureTask) : null;

              self.enqueue("VideoCaptureTask/EndLogEntry", self.logData);

            } else if (self.isQuizTask) {
              if (self.quizResults) {
                self.oldTaskIndex = self.currentTask;
                self.logData.fromTaskId = self.story.tasks[self.oldTaskIndex].id;

              if(self.story.tasks[prevTaskindex].quizTask){
                setTimeout(() => {
                  self.resetQuizButtons = !self.resetQuizButtons;
                }, 200);
              }

              if (prevTaskindex > -1) {
                self.currentTask = prevTaskindex;
                localStorage.setItem('lastTask', displayId);
              } else {
                if (self.$route.params.isStudent)
                  self.backToStudentMenu();
              }
              
                self.logData.toTaskId = self.story.tasks[self.currentTask].id;

                self.$store.dispatch("updateTheme", "dark");

                self.enqueue("QuizTask/EndLogEntry", self.logData);
              }
            } else if (self.isTextNavigationTask) {
              var textNavigation = self.story.tasks[self.currentTask].textNavigationTask;

                self.oldTaskIndex = self.currentTask;
                self.logData.fromTaskId = self.story.tasks[self.oldTaskIndex].id;

                if (prevTaskindex > -1) {
                  self.currentTask = prevTaskindex;
                  localStorage.setItem('lastTask', displayId);
                } else {
                  if (self.$route.params.isStudent)
                    self.backToStudentMenu();
                }

                self.logData.toTaskId = self.story.tasks[self.currentTask].id;

                self.enqueue("TextNavigationTask/EndLogEntry", self.logData);
            } else if (self.isPodcastTask) {

              self.oldTaskIndex = self.currentTask;
              self.logData.fromTaskId = self.story.tasks[self.oldTaskIndex].id;

              if (prevTaskindex > -1) {
                self.currentTask = prevTaskindex;
              } else {
                if (self.$route.params.isStudent)
                  self.backToStudentMenu();
              }

              self.logData.toTaskId = self.story.tasks[self.currentTask].id;

              self.enqueue("PodcastTask/EndLogEntry", self.logData);

              if(self.podcastPlayer)
                self.podcastPlayer.destroy();
            } else if (self.isVideoQuizTask) {
              if(self.timeCapture.captureTimeForAssessments && self.$siteTypeId() != 1){
                self.videoQuizBackDisplayId = displayId;
                self.videoQuizPrevTaskIndex = prevTaskindex;

                if(self.isQuestionPopupActive)
                  self.isQuestionPopupActive = false;

                self.videoQuizTaskTimeCapturePopup = true;
              }else{
                self.oldTaskIndex = self.currentTask;
                self.logData.fromTaskId = self.story.tasks[self.oldTaskIndex].id;

                if (prevTaskindex > -1) {
                  self.currentTask = prevTaskindex;
                  localStorage.setItem('lastTask', displayId)
                } else {
                  if (self.$route.params.isStudent)
                    self.backToStudentMenu();
                }

                self.logData.toTaskId = self.story.tasks[self.currentTask].id;

                if(self.videoQuiz) {
                  self.finishVideoQuiz();

                  var oldVideoElement = document.getElementById("quiz-m3u8-player");
                  if (oldVideoElement) {
                    oldVideoElement.remove();
                  }
                  
                  self.enqueue("VideoQuizTask/EndLogEntry", self.logData);
                }
              }
            }
            else if (self.isNavigationTask){
              var NavigationTask = self.story.tasks[self.currentTask].navigationTask;

              self.oldTaskIndex = self.currentTask;
              self.logData.fromTaskId = self.story.tasks[self.oldTaskIndex].id;

              if (prevTaskindex > -1) {
                self.currentTask = prevTaskindex;
                localStorage.setItem('lastTask', displayId)
              } else {
                if (self.$route.params.isStudent)
                  self.backToStudentMenu();
              }

              self.logData.toTaskId = self.story.tasks[self.currentTask].id;

              self.enqueue("NavigationTask/EndLogEntry", self.logData);
              
            }
          }
          else{
            self.$vs.notify({
              title:'Information',
              color: "warning",
              text: "You can not move back from this point",
              position:'top-right',
              iconPack: 'feather',
              icon:'icon-mail'
            });
          } 
        }
        else if (self.currentTask == -1) {
          self.currentTask--;
        }
      },
      logoutStudent() {
        this.$endUserSession();
      
        window.location.replace("/login");
        this.$vs.theme({ primary: '#7367F0' });
        localStorage.removeItem("userInfo");
    
        this.$acl.change("");
        localStorage.setItem("permissions", "");
        localStorage.setItem("userSiteInfo", "");
        localStorage.setItem("currentModule", "");
        localStorage.setItem("Current_User_Id", "");
      },
      mobilePromptCancelled() {
        var self = this;
        self.$router.push({ name: 'mobileDetected', params: { isStudent: self.$route.params.isStudent } });
      },
      openBackpack() {
        var self = this;
        self.backpackPopupActive = true;
        self.getBackpackDocuments();
        self.getBackpackNotes();
      },
      getBackpackDocuments() {
        var self = this;
        self.showLoadingOnBackpackDocsTable();

        var onSuccess = function (response) {
          self.backpackDocs = response.data;
        };
        var onFinally = function() {
          self.$vs.loading.close(self.$refs.backpackDocsTable.$el);
        };

        self.$ajaxGet(self, "student/getbackpackcontent?studentId=" + self.currentUserId + "&moduleId=" + self.currentModuleId, onSuccess, onFinally);
      },
      getBackpackNotes() {
        var self = this;
        self.showLoadingOnBackpackNotesTable();

        var onSuccess = function (response) {
          self.backpackNotes = response.data;
        };
        var onFinally = function() {
          self.$vs.loading.close(self.$refs.backpackNotesTable.$el);
        };

        self.$ajaxGet(self, "Student/GetNotes?studentId=" + self.currentUserId + "&moduleId=" + self.currentModuleId, onSuccess, onFinally);
      },
      openSelectedTask(task) {
        var self = this;
        if(task.sceneId){
          window.open('../story?mode=previewScene&sceneId=' + task.sceneId, "_blank");
        }else
          window.open(task.fileUrl);
      },
      emailTask(fileUrl) {
        var self = this;

        var onSuccess = function (response) {
          self.$vs.notify({
            title:'Information',
            color: "success",
            text: "Document Emailed",
            position:'top-right',
            iconPack: 'feather',
            icon:'icon-mail'
          });
        };

        self.$ajaxGet(self, "Student/SendDocumentEmail?studentId=" + self.currentUserId + "&fileUrl=" + fileUrl, onSuccess);
      },
      addNewNote() {
        var self = this;
        self.notesMode = "addedit";
        self.noteHeading = "New Note";
      },
      editNote(note) {
        var self = this;
        self.notesMode = "addedit";
        self.noteHeading = "Edit Note";
        self.noteData.id = note.id;
        self.noteData.title = note.title;
        self.noteData.body = note.body;
      },
      saveNote() {
        this.$validator.validateAll().then(result => {
          var self = this;
          if (result) {
            self.showLoadingOnSaveNoteButton();
            self.noteData.studentId = self.currentUserId;
            self.noteData.moduleId = self.currentModuleId;

            var onSuccess = response => {
              self.initNoteValues();
              self.getBackpackNotes();
              self.$vs.notify({
                title:'Information',
                color: "success",
                text: "Note Saved",
                position:'top-right',
                iconPack: 'feather',
                icon:'icon-save'
              });
            };
            var onFinally = function (){
              self.$vs.loading.close(self.$refs.saveNoteButton.$el);
            };

            self.$ajaxPost(self, "Student/AddEditNote", self.noteData, onSuccess, onFinally);
          } else {
            self.$vs.notify({
              title:'Attention',
              color: "warning",
              text: self.$validator.errors.items[0].msg,
              position:'top-right',
              iconPack: 'feather',
              icon:'icon-info'
            });
          }
        });
      },
      deleteNote() {
        var self = this;
        self.showLoadingOnDeleteNoteButton();

        var onSuccess = response => {
          self.initNoteValues();
          self.getBackpackNotes();
          self.$vs.notify({
            title:'Information',
            color: "success",
            text: "Note Deleted",
            position:'top-right',
            iconPack: 'feather',
            icon:'icon-trash'
          });
        };
        var onFinally = function () {
          self.$vs.loading.close(self.$refs.deleteNoteButton.$el);
        };

        self.$ajaxDelete(self, "Student/DeleteNote/" + self.noteData.id, onSuccess, onFinally);
      },
      closeNote() {
        this.initNoteValues();
      },
      initNoteValues() {
        var self = this;
        self.notesMode = "list";
        self.noteData.id = 0;
        self.noteData.studentId = 0;
        self.noteData.moduleId = 0;
        self.noteData.title = "";
        self.noteData.body = "";
      },
      quizFinished(results){
        var self = this;
        self.showBackButton();
        self.showHomeButton = true;
        self.quizResults = results;
        self.studentCoins = self.quizResults.coins;
      },
      enqueue(messageType, logPayload) {
        this.queue.push({
          type: messageType,
          payload: {
            logIdentifier: logPayload.logIdentifier.toString(),
            toTaskId: logPayload.toTaskId,
            fromTaskId: logPayload.fromTaskId,
            taskId: logPayload.taskId,
            passingScore: logPayload.passingScore,
            passingPercent: logPayload.passingPercent,
            awardedScore: logPayload.awardedScore,
            quizDuration: logPayload.quizDuration,
            awardedPercent: logPayload.awardedPercent,
            quizTitle: logPayload.quizTitle,
            quizStatus: logPayload.quizStatus,
            completed: logPayload.completed,
            uploadedFiles: logPayload.uploadedFiles,
            videoCaptureUrl: logPayload.videoCaptureUrl,
            percentLeft: logPayload.percentLeft,
            daysLeft: logPayload.daysLeft,
            quizId: logPayload.quizId,
            timeTaken: logPayload.timeTaken,
            timeCapture: logPayload.timeCapture,
          },
          //retries: retryAttempts
        })
      },
      reloadVideoCapture() {
        document.getElementById('iFrameVideoCapture').src;
      },
      dequeue() {
        return this.queue.shift();
      },
      startProcessor() {
        var self = this;
        var onSuccess = function (response) {
          var next = self.dequeue();
          if (next)
            self.process(next, onSuccess);
        };
        setInterval(function () {
          if (self.queue.length > 0) {
            self.process(self.dequeue(), onSuccess)
          }
        }, 3000)
      },
      process(queueItem, successFunc) {
        var self = this;
        if (queueItem) {
          self.$ajaxPost(self, queueItem.type, queueItem.payload, function(response){
            if(!isNaN(parseInt(response.data))){
              self.studentCoins = response.data;
            }
            successFunc();
          });
        }
      },
      optionClicked(option) {
        var self = this;
        self.oldTaskIndex = self.currentTask;
        self.logData.logIdentifier = self.uuid;
        self.logData.toTaskId = self.story.tasks[option.taskId].id;

        self.enqueue("DialogTask/EndLogEntry", self.logData);
        
        localStorage.setItem('lastTask', option.displayId)

        self.currentTask = option.taskId;
      },
      textNavOptionClicked(option) {
        var self = this;
        self.currentScene.imageUrl = "";
        self.currentScene.musicUrl = "";
        self.oldTaskIndex = self.currentTask;
        self.logData.logIdentifier = self.uuid;
        self.logData.toTaskId = self.story.tasks[option.taskId].id;

        self.enqueue("TextNavigationTask/EndLogEntry", self.logData);

        localStorage.setItem('lastTask', option.displayId)

        self.currentTask = option.taskId;
      },
      plotPoints() {
        var self = this;
        self.navigation = self.story.tasks[self.currentTask].navigationTask;
        var xCoords = [];
        var yCoords = [];
        var correctCoordinates = [];

        self.mapLocations = self.navigation.locationOptions.map((item, index) => {
          correctCoordinates = "";
          if(item.goTo){
            

            xCoords = JSON.parse(item.navigationMapLocation.coordinates).map((val, i) => {
              if (i % 2 === 0)
                return val
            }).filter(function (val) { return val; });;

            yCoords = JSON.parse(item.navigationMapLocation.coordinates).map((val, i) => {
              if (i % 2 === 1)
                return val
            }).filter(function (val) { return val; });

            var backgroundHeight = ((item.navigationMapLocation.imgHeight / item.navigationMapLocation.imgWidth) * self.backgroundCardWidth);
            for (var i = 0; i < yCoords.length; i++) {
              correctCoordinates += Math.round((xCoords[i] * self.backgroundCardWidth)) + "," + Math.round((yCoords[i] * backgroundHeight)) + " ";
            }
            return { coordinates: correctCoordinates.substring(0, correctCoordinates.length - 1), goTo: item.goTo, moduleId: item.moduleId};
          }
        })
      },
      mapLocationClicked(location) {
        var self = this;
        var clickedLocation = location;
        self.oldTaskIndex = self.currentTask;
        self.logData.fromTaskId = self.story.tasks[self.oldTaskIndex].id;

        var currentModuleId = "";
        if(Object.keys(self.$route.query).length != 0)
          currentModuleId = parseInt(self.$route.query.moduleId);
        if(Object.keys(self.$route.params).length != 0)
          currentModuleId = parseInt(self.$route.params.moduleId)

        if(parseInt(clickedLocation.moduleId) == currentModuleId){
          self.currentTask = self.story.tasks.map(function(item){
            return item.displayId;
          }).indexOf(clickedLocation.goTo);

          localStorage.setItem('lastTask', clickedLocation.goTo)

          self.logData.toTaskId = self.story.tasks[self.currentTask].id;
          
          self.enqueue("NavigationTask/EndLogEntry", self.logData);
        } else{
          self.logData.toTaskId = self.story.tasks[self.oldTaskIndex].navigationTask.locationOptions.filter(function(item){return item.goTo == location.goTo})[0].nextTaskId;
          self.enqueue("NavigationTask/EndLogEntry", self.logData);
          setInterval(function () {
            if (self.queue.length == 0) {
              self.$router.replace({ name: 'StoryViewer', params: { mode: "previewStory", taskDisplayId: clickedLocation.goTo, moduleId: clickedLocation.moduleId } });
            }
          }, 500)
        }
      },
      speak(voice, rate, text) {
        var self = this;
        talkify.config = {
          remoteService: {
            host: 'https://talkify.net',
            speechBaseUrl: "/api/speech/v1",
            apiKey: 'ca46f84e-0152-4ec0-9812-04ee04b7aa76',
            active: true //True to use Talkifys language engine and hosted voices. False only works for Html5Player.
          },
          ui: {
            audioControls: { //If enabled, replaces the built in audio controls. Especially good for the Web Speech API bits
              enabled: false
            }
          },
        }

        this.player.pause();
        this.player.forceVoice({ name: voice })
        this.player.setRate(rate - 5); // from -5 to 5
        this.player.playText(text);
      },
      successUpload(data) {
        if (this.upload.allowMultiple)
          this.uploadedFiles.push(data[0].url);
        else {
          if (this.uploadedFiles == 0)
            this.uploadedFiles.push(data[0].url);
          else
            this.$vs.notify({
              time: 5500,
              title: 'Error',
              color: "danger",
              text: "You can only upload ONE (1) file. Remove the previous uploaded file before uploading a new one.",
              position: 'top-right',
              iconPack: 'feather',
              icon: 'icon-alert-circle'
            });
        }
        this.messageType = "uploadType";
        this.$vs.loading.close(this.$refs.fileUpload.$el);
		    this.isLoading = false;
      },
      successUploadVideoRecording(data) {
        this.videoCaptureUrl = data[0].url;
        this.$vs.loading.close(this.$refs.videoUpload.$el);
	      this.isVideoLoading = false;
        this.messageType = "uploadType";
      },
      setFileThumb(url) {
        var ext = url.substring(url.lastIndexOf('.') + 1);
        if (ext.includes('mp3'))
          return "https://forty5degreesstorage.blob.core.windows.net/assets/music.jpg";
        else if (ext.includes('jpg') || ext.includes('jpeg') || ext.includes('png') || ext.includes('gif'))
          return "https://forty5degreesstorage.blob.core.windows.net/assets/image.png";
        else if (ext.includes('doc') || ext.includes('xls') || ext.includes('pdf') || ext.includes('ppt') || ext.includes('txt') || ext.includes('rtf'))
          return "https://forty5degreesstorage.blob.core.windows.net/assets/document.png";
        else if (ext.includes('mp4') || ext.includes('wmv') || ext.includes('mov') || ext.includes('webm') || ext.includes('x-matroska') || ext.includes('mkv'))
          return "https://forty5degreesstorage.blob.core.windows.net/assets/video.png";
      },
      previewScene() {
        var sceneId = "";
        if(Object.keys(this.$route.query).length != 0)
          sceneId = this.$route.query.sceneId;
        if(Object.keys(this.$route.params).length != 0)
          sceneId = this.$route.params.sceneId;

        const self = this;
        var onSuccess = function (response) {
          self.scene = response.data;
          self.$refs.audio.currentTime = self.scene.musicPosition;
          self.$refs.audio.volume = 0.2;
        };
        var onFinally = function () {
          self.$vs.loading.close(self.$refs.whole_page.$el);
        };
        self.$ajaxGet(self, "scene/getscene/" + sceneId, onSuccess, onFinally);
      },
      previewStory() {
        if(Object.keys(this.$route.query).length != 0)
          this.currentModuleId = parseInt(this.$route.query.moduleId);
        if(Object.keys(this.$route.params).length != 0)
          this.currentModuleId = parseInt(this.$route.params.moduleId);
        
        if(Object.keys(this.$route.params).length != 0)
          this.isStartTask = this.$route.params.new;

        const self = this;

        localStorage.setItem('lastModule', self.currentModuleId)

        var taskDisplayId = "";
        if(Object.keys(self.$route.query).length != 0)
          taskDisplayId = self.$route.query.taskDisplayId;
        if(Object.keys(self.$route.params).length != 0)
          taskDisplayId = self.$route.params.taskDisplayId;

        var onSuccess = function (response) {
          self.story = response.data;
          self.isBackAllowed = self.story.backActive;
          self.currentTask = self.story.tasks.map((x, index)=>{
            if(x.displayId == taskDisplayId){
              return index;
            }else
            return null
          });
          self.currentTask = self.currentTask.filter(x=>x != null);


          if(self.$siteTypeId() != 1 && self.story.captureTimeForAssessments)
            self.getTimeCaptureDetail();
        };
        var onFinally = function () {
          self.$vs.loading.close(self.$refs.whole_page.$el);
        };

        self.$ajaxGet(self, "course/getstory/" + this.currentModuleId, onSuccess, onFinally);
      },
      resizeCard() {
        var ratio = 0.434;

        if ((window.innerWidth * 0.9) < 1555.55) {
          this.backgroundCardWidth = window.innerWidth * 0.9;
          this.textBoxEdges = window.innerWidth * 0.015;
        } else {
          this.backgroundCardWidth = 1555.55 * 0.9;
          this.textBoxEdges = 1555.55 * 0.015;
        }

        this.backgroundCardHeight = this.backgroundCardWidth * ratio;
        this.textBoxFontSize = this.backgroundCardHeight * 0.035;
        this.descriptionFontSize = this.backgroundCardHeight * 0.028;
        this.titleFontSize = this.backgroundCardHeight * 0.045;
        this.textResultVideoCapture = this.backgroundCardHeight * 0.035;
        this.maxCardHeight = this.maxCardWidth * ratio;
        this.charHeight = this.backgroundCardHeight / 2;

        if (this.navigation.id)
            this.plotPoints();

        if(this.vimeoPlayer) {
            this.vimeoPlayer.element.height = this.backgroundCardHeight;
            this.vimeoPlayer.element.width = this.backgroundCardWidth;
        }
      },
      nextTask() {
        var self = this;
        self.player.pause();
        self.isVideoLoading = false;
        self.isLoading = false;
        self.backArrowClicked = false;
        self.clearIFrameStorage();
        if(self.$route.params.redoTask){
          if (self.isUploadTask) {
            self.logData.toTaskId = self.story.tasks[self.currentTask].id;
            self.logData.timeTaken = self.slidervalue;
            self.oldTaskIndex = self.currentTask;
            self.logData.fromTaskId = self.story.tasks[self.oldTaskIndex].id;
            self.logData.uploadedFiles = self.uploadedFiles;

            self.logData.timeCapture = self.timeCapture.captureTimeForAssessments 
                ? (self.timeCaptureOnUploadTask == null 
                  ? (self.timeCapture.taskClassificationTypeId == 1 
                    ? self.timeCapture.sliderMinFormatives : self.timeCapture.sliderMinSummatives) : self.timeCaptureOnUploadTask) : null;

            self.enqueue("UploadTask/EndLogEntry", self.logData);
            self.backToStudentMenu();
          }
        }
        if (self.currentTask != -1) {
          if (self.isDialogTask) {
            var dialog = self.story.tasks[self.currentTask].dialogTask;
            
            if (dialog.options.length == 0) {
              self.oldTaskIndex = self.currentTask;
              self.logData.fromTaskId = self.story.tasks[self.oldTaskIndex].id;
              self.logData.toTaskId = self.story.tasks[self.currentTask].id;
              self.enqueue("DialogTask/EndLogEntry", self.logData);
              
              var nextTask =  self.story.tasks.map(function (item) {
                return item.displayId;
              }).indexOf(dialog.goTo);
              
              if (nextTask > -1) {
                localStorage.setItem('lastTask', dialog.goTo);
                self.currentTask = nextTask;    
              } else if (self.$route.params.isStudent){
                self.backToStudentMenu();
              }
            }
          } else if (self.isVideoTask) {
            self.oldTaskIndex = self.currentTask;
            self.logData.fromTaskId = self.story.tasks[self.oldTaskIndex].id;

            var nextTask =  self.story.tasks.map(function (item) {
              return item.displayId;
            }).indexOf(self.video.goTo);

            if (nextTask > -1) {
              localStorage.setItem('lastTask', self.video.goTo);
              self.currentTask = nextTask;
            } else if (self.$route.params.isStudent){
              self.backToStudentMenu();
            }

            self.logData.toTaskId = self.story.tasks[self.currentTask].id;

            if(self.video && !self.video.ad)
              self.enqueue("VideoTask/EndLogEntry", self.logData);

            if(self.videoPlayer)
              self.videoPlayer.destroy();

            if(self.vimeoPlayer)
              self.vimeoPlayer.destroy();

            self.$refs.youtubePlayer.player.clearVideo();
            self.$refs.youtubePlayer.player.stopVideo();

            var oldVideoElement = document.getElementById("m3u8-player");
            if (oldVideoElement) {
              oldVideoElement.remove();
            }
          } else if (self.isISpringQuizTask) {
            if (self.ispringquiz.quizResults) {

              self.checkIfTempiSpringLogExists(() => {
                self.oldTaskIndex = self.currentTask;
                self.logData.fromTaskId = self.story.tasks[self.oldTaskIndex].id;
                self.logData.toTaskId = self.story.tasks[self.currentTask].id;
                self.enqueue("ISpringQuizTask/EndLogEntry", self.logData);

                var nextTask = self.story.tasks.map(function (item) {
                  return item.displayId;
                }).indexOf(self.ispringquiz.quizResults.quizStatus == "Passed" || self.ispringquiz.quizResults.quizStatus == "Completed" ? self.ispringquiz.passTaskGoto : self.ispringquiz.failTaskGoto);

                if (nextTask > -1) {
                  localStorage.setItem('lastTask', self.ispringquiz.quizResults.quizStatus == "Passed" || self.ispringquiz.quizResults.quizStatus == "Completed" ? self.ispringquiz.passTaskGoto : self.ispringquiz.failTaskGoto)
                  self.currentTask = nextTask;
                } else if (self.$route.params.isStudent){
                  self.backToStudentMenu();
                }
              });
            }
          } else if (self.isPresentationTask) {

            var styleB = false;
            if((Object.keys(self.$route.params)!=0)){
                if(self.$route.params.styleB)
                  styleB= true;
            }

            if(styleB){
              var onFinally = e => {
                var nextTask = self.story.tasks.map(function (item) {
                  return item.displayId;
                }).indexOf(self.presentation.goTo);

                if (nextTask > -1) {
                  localStorage.setItem('lastTask', self.presentation.goTo)
                  self.currentTask = nextTask;
                } else if (self.$route.params.isStudent){
                  self.backToStudentMenu();
                }
              }

              var onSuccess = response =>{}

              self.logData.toTaskId = self.story.tasks[self.currentTask].id;
              self.oldTaskIndex = self.currentTask;
              self.logData.fromTaskId = self.story.tasks[self.oldTaskIndex].id;
              self.$ajaxPost(self, "PresentationTask/EndLogEntry" , self.logData , onSuccess, onFinally);
            }
            else{
              self.logData.toTaskId = self.story.tasks[self.currentTask].id;
              self.oldTaskIndex = self.currentTask;
              self.logData.fromTaskId = self.story.tasks[self.oldTaskIndex].id;
              self.enqueue("PresentationTask/EndLogEntry", self.logData);

              var nextTask = self.story.tasks.map(function (item) {
                return item.displayId;
              }).indexOf(self.presentation.goTo);

              if (nextTask > -1) {
                localStorage.setItem('lastTask', self.presentation.goTo)
                self.currentTask = nextTask;
              } else if (self.$route.params.isStudent){
                self.backToStudentMenu();
              }
            }

            
          } else if (self.isDocumentTask) {
            self.logData.toTaskId = self.story.tasks[self.currentTask].id;
            self.oldTaskIndex = self.currentTask;
            self.logData.fromTaskId = self.story.tasks[self.oldTaskIndex].id;
            self.enqueue("DocumentTask/EndLogEntry", self.logData);

            var nextTask = self.story.tasks.map(function (item) {
              return item.displayId;
            }).indexOf(self.document.goTo);

            if (nextTask > -1) {
              localStorage.setItem('lastTask', self.document.goTo)
              self.currentTask = nextTask;
            } else if (self.$route.params.isStudent){
              self.backToStudentMenu();
            }
          } else if (self.isUploadTask) {
            self.logData.toTaskId = self.story.tasks[self.currentTask].id;
            self.logData.timeTaken = self.slidervalue;
            self.oldTaskIndex = self.currentTask;
            self.logData.fromTaskId = self.story.tasks[self.oldTaskIndex].id;
            self.logData.uploadedFiles = self.uploadedFiles;

            self.logData.timeCapture = self.timeCapture.captureTimeForAssessments 
                ? (self.timeCaptureOnUploadTask == null 
                  ? (self.timeCapture.taskClassificationTypeId == 1 
                    ? self.timeCapture.sliderMinFormatives : self.timeCapture.sliderMinSummatives) : self.timeCaptureOnUploadTask) : null;

            self.enqueue("UploadTask/EndLogEntry", self.logData);

            var nextTask = self.story.tasks.map(function (item) {
              return item.displayId;
            }).indexOf(self.upload.goTo);

            if (nextTask > -1) {
              localStorage.setItem('lastTask', self.upload.goTo);
              self.currentTask = nextTask;
            } else if (self.$route.params.isStudent){
              self.backToStudentMenu();
            }
          } else if (self.isVideoCaptureTask && self.$route.params.styleB==true) {
            self.logData.toTaskId = self.story.tasks[self.currentTask].id;
            self.logData.videoCaptureUrl = self.videoCaptureUrl;
            self.oldTaskIndex = self.currentTask;
            self.logData.fromTaskId = self.story.tasks[self.oldTaskIndex].id;

            self.logData.timeCapture = self.timeCapture.captureTimeForAssessments 
                ? (self.timeCaptureOnVideoCaptureTask == null 
                  ? (self.timeCapture.taskClassificationTypeId == 1 
                    ? self.timeCapture.sliderMinFormatives : self.timeCapture.sliderMinSummatives) : self.timeCaptureOnVideoCaptureTask) : null;

            if(self.$route.params.styleB){
              var onSuccess = response => {
                this.backToStudentMenu();
              }
              this.$ajaxPost(self,"VideoCaptureTask/EndLogEntry", self.logData, onSuccess)
            }
          }
          else if (self.isVideoCaptureTask) {
            self.logData.toTaskId = self.story.tasks[self.currentTask].id;
            self.logData.videoCaptureUrl = self.videoCaptureUrl;
            self.oldTaskIndex = self.currentTask;
            self.logData.fromTaskId = self.story.tasks[self.oldTaskIndex].id;

            self.logData.timeCapture = self.timeCapture.captureTimeForAssessments 
                ? (self.timeCaptureOnVideoCaptureTask == null 
                  ? (self.timeCapture.taskClassificationTypeId == 1 
                    ? self.timeCapture.sliderMinFormatives : self.timeCapture.sliderMinSummatives) : self.timeCaptureOnVideoCaptureTask) : null;
            
            self.enqueue("VideoCaptureTask/EndLogEntry", self.logData);

            self.messageType = "";

            var nextTask = self.story.tasks.map(function (item) {
              return item.displayId;
            }).indexOf(self.videoCapture.goTo);

            if (nextTask > -1) {
              localStorage.setItem('lastTask', self.videoCapture.goTo);
              self.currentTask = nextTask;
            } else if (self.$route.params.isStudent){
              self.backToStudentMenu();
            }
          } 
          else if (self.isQuizTask) {
            if (self.quizResults) {
              self.$store.dispatch("updateTheme", "dark");

              self.logData.toTaskId = self.story.tasks[self.currentTask].id;
              self.oldTaskIndex = self.currentTask;
              self.logData.fromTaskId = self.story.tasks[self.oldTaskIndex].id;

              var nextTask =  self.story.tasks.map(function (item) {
                return item.displayId;
              }).indexOf(self.quizResults.finalResult == "Fail" ? self.quiz.failTaskGoto : self.quiz.passTaskGoto);
              

              if(self.story.tasks[nextTask].quizTask){
                setTimeout(() => {
                  self.resetQuizButtons = !self.resetQuizButtons;
                }, 200);
              }

              if (nextTask > -1) {
                localStorage.setItem('lastTask', self.quizResults.finalResult == "Fail" ? self.quiz.failTaskGoto : self.quiz.passTaskGoto);
                self.currentTask = nextTask;
              } else if (self.$route.params.isStudent){
                self.backToStudentMenu();
              } 
            }
          } else if (self.isTextNavigationTask) {
            var textNavigation = self.story.tasks[self.currentTask].textNavigationTask;
            if (textNavigation.options.length == 0) {
              self.logData.toTaskId = self.story.tasks[self.currentTask].id;
              self.oldTaskIndex = self.currentTask;
              self.logData.fromTaskId = self.story.tasks[self.oldTaskIndex].id;
              self.enqueue("TextNavigationTask/EndLogEntry", self.logData);

              var nextTask =  self.story.tasks.map(function (item) {
                return item.displayId;
              }).indexOf(textNavigation.goTo);

              if (nextTask > -1) {
                localStorage.setItem('lastTask', textNavigation.goTo);
                self.currentTask = nextTask;
              } else if (self.$route.params.isStudent){
                self.backToStudentMenu();
              }
            }
          } else if (self.isPodcastTask) {
            self.oldTaskIndex = self.currentTask;
            self.logData.fromTaskId = self.story.tasks[self.oldTaskIndex].id;
            self.logData.toTaskId = self.story.tasks[self.currentTask].id;
            self.enqueue("PodcastTask/EndLogEntry", self.logData);

            var nextTask =  self.story.tasks.map(function (item) {
              return item.displayId;
            }).indexOf(self.podcast.goTo);

            if (nextTask > -1) {
              localStorage.setItem('lastTask', self.podcast.goTo);
              self.currentTask = nextTask; 
            } else if (self.$route.params.isStudent){
              self.backToStudentMenu();
            }

            if(self.podcastPlayer)
              self.podcastPlayer.destroy();
          } else if (self.isVideoQuizTask) {
            self.oldTaskIndex = self.currentTask;
            self.logData.fromTaskId = self.story.tasks[self.oldTaskIndex].id;
            self.logData.toTaskId = self.story.tasks[self.currentTask].id;

            if(self.timeCapture.captureTimeForAssessments && self.$siteTypeId() != 1){
              self.videoQuizTaskTimeCapturePopup = true;
            }else{
              self.enqueue("VideoQuizTask/EndLogEntry", self.logData);

                var nextTask =  self.story.tasks.map(function (item) {
                  return item.displayId;
                }).indexOf(self.videoQuiz.goTo);

                if (nextTask > -1) {
                  if(self.videoQuiz) {
                    self.finishVideoQuiz();
      
                    var oldVideoElement = document.getElementById("quiz-m3u8-player");
                    if (oldVideoElement) {
                      oldVideoElement.remove();
                    }
                    localStorage.setItem('lastTask', self.videoQuiz.goTo);
                    self.currentTask = nextTask;
                  } 
                }else if (self.$route.params.isStudent){
                  self.backToStudentMenu();
                }
              }
          } else if (self.currentTask == -1) {
            self.currentTask++;
          }
        }
      },
      onPlayerEnded() {
        this.nextTask();
      },
      getCurrentUserId() {

        var self = this;

        var userIdFromLocalStorage = localStorage.getItem("Current_User_Id");

        if (userIdFromLocalStorage != undefined && userIdFromLocalStorage != null && userIdFromLocalStorage != "") {
          self.currentUserId = JSON.parse(userIdFromLocalStorage);
          return;
        }

        var onSuccess = response => {
          localStorage.setItem("Current_User_Id", response.data);
          self.currentUserId = JSON.parse(localStorage.getItem('Current_User_Id'));
        };
        this.$ajaxGet(self, "user/GetUserId", onSuccess);
      },
      clearIFrameStorage(whenDone) {
        document.getElementById('ispringQuizFrame').contentWindow.postMessage({
          event_id: 'ispringdone'
        }, "*");

        if (whenDone && typeof whenDone == "function")
          whenDone();
      },
      showLoadingOnVideoUploader(){
        var self = this;
        self.isVideoLoading = true;
        self.$vs.loading({
          type: "material",
          container: self.$refs.videoUpload.$el,
          scale: 0.45
        });
      },
      showLoadingOnUploader(){
        var self = this;
        self.isLoading = true;
        self.$vs.loading({
          type: "material",
          container: self.$refs.fileUpload.$el,
          scale: 0.45
        });
      },
      showLoadingOnBackpackDocsTable(){
        var self = this;
        self.$vs.loading({
          color: "#727272",
          type: "corners",
          container: self.$refs.backpackDocsTable.$el,
          scale: 1
        });
      },
      showLoadingOnBackpackNotesTable() {
        var self = this;
        self.$vs.loading({
          color: "#727272",
          type: "corners",
          container: self.$refs.backpackNotesTable.$el,
          scale: 1
        });
      },
      showLoadingOnSaveNoteButton() {
        var self = this;
        self.$vs.loading({
          type: "material",
          container: self.$refs.saveNoteButton.$el,
          scale: 0.30
        });
      },
      showLoadingOnDeleteNoteButton() {
        var self = this;
        self.$vs.loading({
          type: "material",
          container: self.$refs.deleteNoteButton.$el,
          scale: 0.30
        });
      },
      showLoadingOnElement(element, scale, type) {
        var self = this;
        self.$vs.loading({
          type: type,
          container: self.$refs[element].$el,
          scale: scale
        });
      },
      getCoins() {
        var self = this;
        var studentId = localStorage.getItem("Current_User_Id");
        var moduleId = localStorage.getItem("currentModule");

        var onSuccess = function (response) {
          self.studentCoins = response.data;
        };

        self.$ajaxGet(self, "CoinTransaction/GetCoins?studentId=" + studentId + "&moduleId=" + moduleId, onSuccess);
      },
      async onCapture () {
        if(this.$refs.webcam) {
          this.img = await this.$refs.webcam.capture();

          var block = this.img.split(";");
          var contentType = block[0].split(":")[1];
          if(contentType != ","){
            var realData = block[1].split(",")[1];
            var blob = await this.b64toBlob(realData, contentType);
            this.uploadSnapshot(blob);
          }
        }
      },
      onError (error) {
        var self = this;

        var mode = "";
        if(Object.keys(self.$route.query).length != 0)
          mode = self.$route.query.mode;
        if(Object.keys(self.$route.params).length != 0)
          mode = self.$route.params.mode;

        if(!self.isMobile() && mode == "story" && self.isQuizTask.isDecisive){
          self.$vs.dialog({
            type: "confirm",
            color: 'success',
            title: 'Camera Access Denied',
            text: 'Before you can continue, please allow access to your camera / webcam.\n\nThis can typically be done by clicking on the icon with the small red cross on the far-right, or on the lock on the far-left, in the address bar.\n\nWhen you are done, click the button below.\n\nPlease note that you will be redirected back to the menu and that you will just have to select this task again to continue from in the \'Continue Where Left Off\' section.',
            accept: self.reloadPage,
            cancel: self.reloadPage,
            acceptText: "Alright, I've done it!",
          })
        }
      },
      reloadPage() {
        this.$router.go();
      },
      onCameras (cameras) {
        var self = this;
        if(this.$route.params.isStudent) {
          self.devices = cameras;
          setTimeout(function() {
            if ((self.isISpringQuizTask && self.isISpringQuizTask.isDecisive) || (self.isQuizTask && self.isQuizTask.isDecisive)) {
              self.onCapture();
              if (!self.isTakingSnapshots) {
                self.snapshotInterval = setInterval(function () {
                  if ((self.isISpringQuizTask && self.isISpringQuizTask.isDecisive) || (self.isQuizTask && self.isQuizTask.isDecisive)) {
                    self.onCapture();
                    self.isTakingSnapshots = true;
                  }
                }, 180000)
              }
            }
          }, 5000)
        }
      },
      b64toBlob(b64Data, contentType, sliceSize) {
        contentType = contentType || '';
        sliceSize = sliceSize || 512;

        var byteCharacters = window.atob(b64Data);
        var byteArrays = [];

        for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
          var slice = byteCharacters.slice(offset, offset + sliceSize);
          var byteNumbers = new Array(slice.length);
          for (var i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
          }
          var byteArray = new Uint8Array(byteNumbers);
          byteArrays.push(byteArray);
        }

        var blob = new Blob(byteArrays, {type: contentType});
        return blob;
      },
      uploadSnapshot(blob) {
        var self = this;
        var formData = new FormData();
        formData.append('image', blob, "student");

        var onSuccess = response => {};

        self.$ajaxPost(self, "Student/UploadSnapshot?logIdentifier=" + self.uuid, formData, onSuccess);
      },
      downloadPinnedDoc(documentUrl) {
        window.open(documentUrl);
      },
      setDeviceType() {
        var self = this;

        var module = {
          options: [],
          header: [navigator.platform, navigator.userAgent, navigator.appVersion, navigator.vendor, window.opera],
          dataos: [
            { name: 'Windows Phone', value: 'Windows Phone', version: 'OS' },
            { name: 'Windows', value: 'Win', version: 'NT' },
            { name: 'iPhone', value: 'iPhone', version: 'OS' },
            { name: 'iPad', value: 'iPad', version: 'OS' },
            { name: 'Kindle', value: 'Silk', version: 'Silk' },
            { name: 'Android', value: 'Android', version: 'Android' },
            { name: 'PlayBook', value: 'PlayBook', version: 'OS' },
            { name: 'BlackBerry', value: 'BlackBerry', version: '/' },
            { name: 'Macintosh', value: 'Mac', version: 'OS X' },
            { name: 'Linux', value: 'Linux', version: 'rv' },
            { name: 'Palm', value: 'Palm', version: 'PalmOS' },
            { name: 'Huawei', value: 'Huawei', version: 'OS' }
          ],
          databrowser: [
            { name: 'Chrome', value: 'Chrome', version: 'Chrome' },
            { name: 'Firefox', value: 'Firefox', version: 'Firefox' },
            { name: 'Safari', value: 'Safari', version: 'Version' },
            { name: 'Internet Explorer', value: 'MSIE', version: 'MSIE' },
            { name: 'Opera', value: 'Opera', version: 'Opera' },
            { name: 'BlackBerry', value: 'CLDC', version: 'CLDC' },
            { name: 'Mozilla', value: 'Mozilla', version: 'Mozilla' },
            { name: 'Huawei Browser', value: 'Huawei Browser', version: 'Huawei' }
          ],
          init: function () {
            var agent = this.header.join(' '),
              os = this.matchItem(agent, this.dataos),
              browser = this.matchItem(agent, this.databrowser);

            return { os: os, browser: browser };
          },
          matchItem: function (string, data) {
            var i = 0,
              j = 0,
              html = '',
              regex,
              regexv,
              match,
              matches,
              version;

            for (i = 0; i < data.length; i += 1) {
              regex = new RegExp(data[i].value, 'i');
              match = regex.test(string);
              if (match) {
                regexv = new RegExp(data[i].version + '[- /:;]([\\d._]+)', 'i');
                matches = string.match(regexv);
                version = '';
                if (matches) { if (matches[1]) { matches = matches[1]; } }
                if (matches) {
                  matches = matches.split(/[._]+/);
                  for (j = 0; j < matches.length; j += 1) {
                    if (j === 0) {
                      version += matches[j] + '.';
                    } else {
                      version += matches[j];
                    }
                  }
                } else {
                  version = '0';
                }
                return {
                  name: data[i].name,
                  version: parseFloat(version)
                };
              }
            }
            return { name: 'unknown', version: 0 };
          }
        };

        var e = module.init();

        self.errorData.osName = e.os.name;
        self.errorData.osVersion = e.os.version;
        self.errorData.browserName = e.browser.name;
        self.errorData.browserVersion = e.browser.version;
        self.errorData.navigatorUserAgent = navigator.userAgent;
        self.errorData.navigatorAppVersion = navigator.appVersion;
        self.errorData.navigatorPlatform = navigator.platform;
        self.errorData.navigatorVendor = navigator.vendor;
      },
      submitIssue() {
        var self = this;
        self.helpPopupActive = false;
        self.errorData.taskId = self.story.tasks[self.currentTask].id;
        self.errorData.isMobile = self.isMobile();
        
        var onSuccess = response => {
          self.$vs.notify({
            title:'Information',
            color: "success",
            text: "Issue submitted!",
            position:'top-right',
            iconPack: 'feather',
            icon:'icon-check'
          });
        };

        self.$ajaxPost(self, "Student/LogError", self.errorData, onSuccess);
      },
      error: function(err) {

        console.log(err);
      },
      prevPage() {
        this.scrollToNavbar();
        this.page = this.page - 1;
      },
      nextPage() {
        this.scrollToNavbar();
        this.page = this.page + 1;
      },
      scrollToNavbar() {
        var scrollOptions = {
          easing: "ease-in",
          offset: -500,
          force: true,
          cancelable: true,
          x: false,
          y: true
        };
        var cancelScroll = this.$scrollTo(
          document.getElementById("navbarGlobal"),
          500,
          scrollOptions
        );
      },
      getTimeCaptureDetail(){
        var self = this;

        self.timeCapture.captureTimeForAssessments = self.story.captureTimeForAssessments;
        self.timeCapture.formativeHoursRequired = self.story.formativeHoursRequired;
        self.timeCapture.summativeHoursRequired = self.story.summativeHoursRequired;
        self.timeCapture.taskClassificationTypeId = self.story.tasks[self.currentTask].taskClassificationTypeId;

        var formativesCount = self.story.tasks.filter(x => x.taskClassificationTypeId == 1).length;
        var summativesCount = self.story.tasks.filter(x => x.taskClassificationTypeId == 2).length;

        self.timeCapture.sliderMinFormatives = Math.ceil(self.timeCapture.formativeHoursRequired/formativesCount);
        self.timeCapture.sliderMinSummatives = Math.ceil(self.timeCapture.summativeHoursRequired/summativesCount);

        self.timeCapture.sliderMaxFormatives = Math.ceil(self.timeCapture.sliderMinFormatives + (self.timeCapture.sliderMinFormatives * 50/100));
        self.timeCapture.sliderMaxSummatives = Math.ceil(self.timeCapture.sliderMinSummatives + (self.timeCapture.sliderMinSummatives * 50/100));
      },
      endVideoQuizTaskCourseTaskLog(){
        var self = this;

        self.logData.timeCapture = self.timeCapture.captureTimeForAssessments 
          ? (self.timeCaptureOnVideoQuizTask == null 
            ? (self.timeCapture.taskClassificationTypeId == 1 
              ? self.timeCapture.sliderMinFormatives : self.timeCapture.sliderMinSummatives) : self.timeCaptureOnVideoQuizTask) : null;

        if(self.isQuestionPopupActive)
          self.isQuestionPopupActive = false;

        if(self.backArrowClicked){
          self.oldTaskIndex = self.currentTask;
          self.logData.fromTaskId = self.story.tasks[self.oldTaskIndex].id;

          if (self.videoQuizPrevTaskIndex > -1) {
            self.currentTask = self.videoQuizPrevTaskIndex;
            localStorage.setItem('lastTask', self.videoQuizBackDisplayId)
          } else {
            if (self.$route.params.isStudent)
              self.backToStudentMenu();
          }

          self.logData.toTaskId = self.story.tasks[self.currentTask].id;

          if(self.videoQuiz) {
            self.finishVideoQuiz();

            var oldVideoElement = document.getElementById("quiz-m3u8-player");
            if (oldVideoElement) {
              oldVideoElement.remove();
            }
            self.enqueue("VideoQuizTask/EndLogEntry", self.logData);
          }
        }else{
          var nextTask =  self.story.tasks.map(function (item) {
            return item.displayId;
          }).indexOf(self.videoQuiz.goTo);

          if (nextTask > -1) {
            if(self.videoQuiz) {
              self.finishVideoQuiz();

              var oldVideoElement = document.getElementById("quiz-m3u8-player");
              if (oldVideoElement) {
                oldVideoElement.remove();
              }
              localStorage.setItem('lastTask', self.videoQuiz.goTo);
              self.currentTask = nextTask;
            } 
          }else if (self.$route.params.isStudent){
            self.backToStudentMenu();
          }

          self.enqueue("VideoQuizTask/EndLogEntry", self.logData);
        }

        self.videoQuizTaskTimeCapturePopup = false;
      },
      checkIfTempiSpringLogExists(whenDone) {
        const self = this;

        self.showLoadingOnElement("whole_page", 1, "material");

        var onSuccess = function (response) {
          var logExists = response.data;

          if (logExists && (whenDone && typeof whenDone == "function")) {
            whenDone();
          } else {
            self.redoIspringPopup = true;
          }
        };
        var onFinally = function () {
          self.$vs.loading.close(self.$refs.whole_page.$el);
        };
        self.$ajaxPost(self, "ISpringQuizTask/CheckIfLogExist", self.logData, onSuccess, onFinally);
      },
      redoIspringQuiz() {
        const self = this;
        self.redoIspringPopup = false;
        var tempUrl = self.ispringQuizUrl;

        self.clearIFrameStorage(() => {
          self.ispringQuizUrl = "";
        });

        setTimeout(() => {
          self.ispringQuizUrl = tempUrl;
        }, 100);
      },
      displayOneTaskAttemptPopup(){
        var self = this;
        if(this.$getTaskAttempt()){
          self.$swal({
            title: 'Before you Start',
            icon:'info',
            html: "If this is not your first attempt, by redoing this task all other attempts will be <strong>DISCARDED</strong>. Only your last attempt will be recorded.",
            customClass: {
              confirmButton: 'vs-component vs-button vs-button-primary vs-button-filled',
            },
            buttonsStyling: false,
          });
        }
      }
    },
    created() {
      document.title = "DigiCampus";
      this.resizeCard();

      if(Object.keys(this.$route.query).length == 0 && Object.keys(this.$route.params).length == 0){
        this.backToStudentMenu();
      }

      var mode = "";
      if(Object.keys(this.$route.query).length != 0)
        mode = this.$route.query.mode;
      if(Object.keys(this.$route.params).length != 0)
        mode = this.$route.params.mode;
        
      this.player = new talkify.TtsPlayer();
      if (mode == "previewScene") {
        this.previewScene();
      } else if (mode == "previewStory") {
        this.previewStory();
        this.isPreview = true;
      } else if (mode == "story") {
        this.previewStory();
      }
    },
    mounted() {
      var self = this;
      self.styleB = self.$route.params.styleB ? true : false;     
      self.rewrite = self.$route.params.rewrite ? true : false;     

      if (self.styleB && self.$route.query.outcome) {
        document.getElementsByTagName('body')[0].style.backgroundColor = "#ffffff";
        document.getElementsByTagName('body')[0].style.backgroundColor = "#ffffff";
        var bodyEl = document.getElementsByTagName('body')[0];
        bodyEl.style.backgroundColor = "#ffffff";
      }

      if(Object.keys(this.$route.query).length > 0 || Object.keys(this.$route.params).length || 0){
        self.showLoadingOnElement("whole_page", 1, "material");
      }
      self.showHomeButton = true;

      if(self.$route.params.coins)
        self.studentCoins = self.$route.params.coins;
      else if(Object.keys(self.$route.params).length === 0 && Object.keys(this.$route.query).length === 0){
        //self.getCoins();
      }        
      self.uploadedFiles = [];
      self.videoCaptureUrl = "";
      self.startProcessor();
      self.resizeCard();
      self.getCurrentUserId();
      self.currentSiteId = self.$getSiteId();
      self.$nextTick(() => {
        window.addEventListener('resize', () => {
          self.resizeCard();
        });
      });
      self.setDeviceType();
      window.addEventListener("message", function () {
        if (event.data.message == 'iFrame') {
          self.videoCaptureUrl = event.data.results.link;
          self.messageType = "recordType";
        }
        if (event.data.event_id == 'ispring') {
          if (self.isISpringQuizTask) {
            self.ispringquiz.quizResults = {};
            self.ispringquiz.quizResults.passingScore = isNaN(event.data.results.passingScore) ? null : event.data.results.passingScore;
            self.ispringquiz.quizResults.passingPercent = isNaN(event.data.results.passingPercent) ? null : event.data.results.passingPercent;
            self.ispringquiz.quizResults.awardedScore = isNaN(event.data.results.awardedScore) ? null : event.data.results.awardedScore;
            self.ispringquiz.quizResults.awardedPercent = isNaN(event.data.results.awardedPercent) ? null : event.data.results.awardedPercent;
            self.ispringquiz.quizResults.quizDuration = event.data.results.quizDuration;
            self.ispringquiz.quizResults.quizTitle = event.data.results.quizTitle;
            self.ispringquiz.quizResults.quizStatus = event.data.results.quizStatus;
            self.ispringquiz.quizResults.completed = true;

            self.logData.passingScore = isNaN(event.data.results.passingScore) ? null : event.data.results.passingScore;
            self.logData.passingPercent = isNaN(event.data.results.passingPercent) ? null : event.data.results.passingPercent;
            self.logData.awardedScore = isNaN(event.data.results.awardedScore) ? null : event.data.results.awardedScore;
            self.logData.quizDuration = event.data.results.quizDuration;
            self.logData.awardedPercent = isNaN(event.data.results.awardedPercent) ? null : event.data.results.awardedPercent;
            self.logData.quizTitle = event.data.results.quizTitle;
            self.logData.quizStatus = self.ispringquiz.quizResults.quizStatus;
            self.logData.completed = self.ispringquiz.quizResults.completed;
          }
        }
      }, false);
      self.$refs.videoUpload.$el.addEventListener("click", function(){
        if(!self.isVideoLoading)
          self.showLoadingOnVideoUploader();
        else{
          self.isVideoLoading = false;
          self.$vs.loading.close(self.$refs.videoUpload.$el);
        }
      });

      window.addEventListener("message", function() {
        if(event.data.event_id == 'hls_end'){
          self.isNextTaskBtnHidden = false;
        }
      }, false);

      self.$refs.fileUpload.$el.addEventListener("click", function(){
        if(!self.isLoading)
          self.showLoadingOnUploader();
        else{
          self.isLoading = false;
          self.$vs.loading.close(self.$refs.fileUpload.$el);
        }
      });
    }
  };
</script>

<style lang="scss">

  @import "@/digicampus/assets/main-digi.scss";

  .vs-con-loading__container{
    height: unset;
  }
  .videoCaptureContainer{
    display: flex;
    justify-content: center;
    padding: 20px;
  }
  .vs-con-loading__container{
      height: 100%;
    }
  .vs-col{
    padding: 0px !important;
  }
  .theme-dark h2{
    color: #000000;
  }
  .textOptionSizing{
    overflow-y: auto;
    height: 60vh;
  }
  .moibleview{
    background-position: center !important;
    background-repeat: no-repeat !important;
    background-size: cover !important;
    max-width: 100% !important;
    max-height: 90vh !important;
    overflow-y: hidden;
  }
  .hoursUsed{
    display:flex ;
    justify-content: center ;
    justify-items: center;
    flex-direction: column;
    text-align: center;
    align-items: center;
    width: 70%;
    margin: 0 auto;
  }
  
  #Back-to-menu{
    position: absolute;
    top: 0;
    left: 0;
    z-index: 50000;
    margin-left: 10px;
    margin-top: 10px;
    cursor: pointer;

    .menuIcon{
      width: 40px;
      height: 40px;
      fill: #808080;
      transition: transform 100ms;
    }
    .menuIcon:hover{
      transform: scale(1.15);
    }
  }

  #new-back-button{
    position: absolute;
    top: 0;
    left: 0;
    z-index: 90000;
    margin-left: 5px;
    margin-top: 55px;
    cursor: pointer;

    .newBackButtonIcon{
      width: 40px;
      height: 40px;
      fill: #808080;
      transition: transform 100ms;
    }
    .newBackButtonIcon:hover{
      width: 45px;
      transform: translate(0, 3px);
    }
  }

  .plyr.plyr--full-ui.plyr--audio {
    padding-top: 50px !important;
  }

  .vx-row > .vx-col{
    padding: 0 1rem;
  }

  #videoFrame .plyr__video-embed {
    padding-bottom: 43.35% !important;
  }

  .plyr video {
    height: 94.6% !important;
    width: 77.2% !important;
  }

  .plyr--video {
    text-align: -webkit-center;
    text-align: -moz-center;
  }

  #videoFrame .plyr {
    max-width: 80% !important;
  }

  body {
    color: #000000;
  }

  .navtaskheadings{
    display: flex !important;
    flex-wrap: wrap;
    justify-content: left;
    flex-direction: column;
    color: #000000 !important;
    text-align: left !important;
    margin-left:20px ;
  }

 #textnavigation-card div.title {
    color: #000000;
    border-radius: 22px;
    padding:10px;
    bottom: 0;
    font-family: 'Montserrat', sans-serif;
    font-weight: 600;
    text-align: center;
    vertical-align: center;
    min-width: 20%;
    display:inline-block;
    position:relative;
  }

  #character-card {
    position: relative;
  }

  #textnavigation-card {
    position: relative;
  }

  #navigation-card {
    position: relative;
  }

  #info-display {
    position: absolute;
    top: 0;
    width: -webkit-fill-available;
    margin: auto;
    left: 0;
    right: 0;
  }

  #back-arrow {
    width: 60px;
    left: 0;
    position: absolute;
    bottom: 0;
    margin-left: 5px;
    z-index: 50000;

    &:hover {
      width: 63px;
      cursor: pointer;
      fill: white;
    }

    &:active {
      width: 60px;
      cursor: pointer;
      opacity: 0.8;
    }
  }

  #back-arrow__hls {
    width: 60px;
    position: absolute;
    z-index: 90000;
    left: 30px;

    &:hover {
      width: 63px;
      cursor: pointer;
      fill: white;
    }

    &:active {
      width: 60px;
      cursor: pointer;
      opacity: 0.8;
    }
  }

  @media screen and (max-width: 980px) {
    #AdditionalResources{
      margin-left: 45px;
      margin-bottom: 30px;
    }
  }

  @media screen and (max-width: 900px) {
    
    .hoursUsed{
      width: 90%;
    }
    #Back-to-menu{
      margin-left: 0px;
    }
    #new-back-button{
      margin-left: 0px;
    }
    #back-arrow {
      width: 40px;
      position: absolute;
      margin-left: 2px;
      left: 0;

      &:hover {
        width: 43px;
        cursor: pointer;
        fill: white;
      }

      &:active {
        width: 40px;
        cursor: pointer;
        opacity: 0.8;
      }
    }

    #back-arrow__hls {
      width: 40px;
      position: absolute;
      z-index: 90000;
      left: 30px;

      &:hover {
        width: 43px;
        cursor: pointer;
        fill: white;
      }

      &:active {
        width: 40px;
        cursor: pointer;
        opacity: 0.8;
      }
    }
  }

  #next-task-arrow {
    position: absolute;
    right: 0;
    z-index: 50000;
    width: 60px;
    margin-right: 5px;

    &:hover {
      width: 63px;
      cursor: pointer;
    }

    &:active {
      width: 60px;
      cursor: pointer;
      opacity: 0.8;
    }
  }

  #next-task-arrow__hls {
    width: 60px;
    position: absolute;
    z-index: 90000;
    right: 60px;

    &:hover {
      width: 63px;
      cursor: pointer;
    }

    &:active {
      width: 60px;
      cursor: pointer;
      opacity: 0.8;
    }
  }

  @media screen and (max-width: 900px) {
    #next-task-arrow {
      width: 40px;
      position: absolute;
      margin-right: 2px;

      &:hover {
        width: 43px;
        cursor: pointer;
      }

      &:active {
        width: 40px;
        cursor: pointer;
        opacity: 0.8;
      }
    }

    #next-task-arrow__hls {
      width: 40px;
      position: absolute;
      z-index: 90000;
      right: 50px;

      &:hover {
        width: 43px;
        cursor: pointer;
      }

      &:active {
        width: 40px;
        cursor: pointer;
        opacity: 0.8;
      }
    }
  }

  #health-container {
    width: -webkit-fill-available;
    text-align: center;
    top: 0;
    left: 0;
    right: 0;

    #another-div {
      top: 0;
      left: 0;
      right: 0;
      margin: auto;
      > span {
        left: -127px;
        top: 2px;
        margin: auto;
        z-index: 50000;
        > svg {
          color: red !important;
        }
      }
    }

    @media screen and (max-width: 900px) {
      #another-div {
        top: 0;
        left: 0;
        right: -22px;
        margin: auto;
        > span {
          left: -69px;
          top: 2px;
          margin: auto;
          z-index: 50000;
          > svg {
            color: red !important;
            height: 16px;
          }
        }
      }
    }

    #health-bar-container {
      margin: auto;
      position: absolute;
      left: 0;
      right: 0;
      top: 5px;
    }

    @media screen and (max-width: 900px) {
      #health-bar-container {
        margin: auto;
        position: absolute;
        left: 0;
        right: 0;
        top: 2px;
      }
    }

    


    #health-bar {
      border: solid;
      height: 14px;
      border-width: thin;
      border-color: white;
      width: 16% !important;
    }

    #coin-container {
      position: absolute;
      top: 3px;
      right: 0px;
      left: 290px;
      margin: auto;

      #coin-gif {
        position: relative;
        top: 0px;
        left: -15px;
        right: 0px;
        margin: auto;
      }

      #total-coins {
        position: absolute;
        right: 0;
        top: 3px;
        left: 50px;
        font-weight: 900;
      }
    }

    @media screen and (max-width: 900px) and (min-width: 601px) {
      #coin-container {
        position: absolute;
        top: 3px;
        right: 0px;
        left: 222px;
        margin: auto;

        #coin-gif {
          position: relative;
          top: 0px;
          left: -38px;
          right: 0px;
          margin: auto;
          height: 16px;
        }

        #total-coins {
          position: absolute;
          right: 0;
          top: 0px;
          left: -12px;
          font-weight: 900;
          font-size: 11px;
        }
      }
    }

    @media screen and (max-width: 600px) {

      #coin-container {
        position: absolute;
        top: 3px;
        right: 0px;
        left: 167px;
        margin: auto;

        #coin-gif {
          position: relative;
          top: 0px;
          left: -31px;
          right: 0px;
          margin: auto;
          height: 16px;
        }

        #total-coins {
          position: absolute;
          right: 0;
          top: 0px;
          left: -4px;
          font-weight: 900;
          font-size: 11px;
        }
      }
    }
  }

  #backpack-container {
    position: absolute;
    top: 0;
    right: 0;
    z-index: 50000;
    margin-right: 4px;
    margin-top: 4px;

    #backpack-img {
      height: 50px;
      fill: white;
      opacity: 0.8;
    }

    #backpack-img:hover {
      height: 52px;
      cursor: pointer;
      fill: white;
      opacity: 1;
    }
    #backpack-img:active {
      height: 50px;
      cursor: pointer;
      opacity: 0.8;
    }
  }

  @media screen and (max-width: 900px) {
    #backpack-container {
      position: absolute;
      top: 0;
      right: 0;
      z-index: 50000;
      margin-right: 4px;
      margin-top: 4px;

      #backpack-img {
        height: 30px;
        fill: white;
        opacity: 1;
      }

      #backpack-img:hover {
        height: 30px;
        cursor: pointer;
        fill: white;
        opacity: 1;
      }

      #backpack-img:active {
        height: 29px;
        cursor: pointer;
        opacity: 0.8;
      }
    }
  }

  #videocapture-card #back-arrow {
    top: 0px;
    left: 0px;
  }

  #videocapture-card .vx-card__collapsible-content {
    position: initial;
  }

  #upload-card #back-arrow {
    top: 0px;
    left: 0px;
  }

  .overflowCardScroll {
    overflow-x: hidden !important;
    overflow-y: scroll !important;
  }

  .backgroundAutoGrow {
    margin: auto;
    background-size: 100% 100% !important;
    background-repeat: no-repeat !important;
  }

  .background-auto-grow-with-repeat {
    margin: auto;
    background-repeat: repeat !important;
  }

  .vs-button-light.vs-button-border:hover, .vs-button-light.vs-button-flat:hover {
    background: rgba(245, 245, 245, 0.3) !important;
  }

  .contentCards {
    margin: auto;
  }

  #upload-card {
    .vx-card__collapsible-content {
      position: initial;
    }
  }

  span {
    font-size: 90%;
    font-style: normal;
    font-weight: bold;
    cursor: pointer;
  }

  #optionText.textStyling:hover { //span:hover
    -webkit-stroke-width: 5.3px;
    stroke-width: 5.3px;
    -webkit-stroke-color: #FFFFFF;
    -webkit-fill-color: #FFFFFF;
    text-shadow: 1px 0px 20px yellow;
    cursor: pointer;
  }

  #optionContainer span {
    font-size: 110%;
    font-style: normal;
    font-weight: bold;
    cursor: pointer;
  }

  #textNavOptionText.textStyling {
    color: #000000;
  }

  #textNavOptionText.textStyling:hover { //span:hover
    -webkit-stroke-width: 5.3px;
    stroke-width: 5.3px;
    -webkit-stroke-color: #FFFFFF;
    -webkit-fill-color: #FFFFFF;
    color: rgb(72, 204, 39);
    cursor: pointer;
  }

  #characterLeft {
    position: absolute;
    -webkit-transform: scaleX(-1);
    transform: scaleX(-1);
    bottom: 0;
    left: 0;
  }

  #characterRight {
    position: absolute !important;
    bottom: 0;
    right: 0;
    -moz-transform: scaleX(-1);
    -o-transform: scaleX(-1);
    -webkit-transform: scaleX(-1);
    transform: scaleX(-1);
    filter: FlipH;
    -ms-filter: "FlipH";
  }

  #characterDiv {
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
  }

  #character-card.backgroundAutoGrow {
    .vx-card__collapsible-content {
      height: 100%;
      .vx-card__body {
        height: 100%;
        
      }
    }
  }

  .speech {
    z-index: 10000;
    position: absolute;
    margin:auto;
    display:block;
    text-align:center;
    bottom: 0;
    left: 0;
    right: 0;
  }

  #textNavDescription {
    color: #c2c6dc;
    padding:10px;
    bottom: 0;
    font-family: 'Montserrat', sans-serif !important;
    text-align: left;
    vertical-align: center;
    max-width: 95%;
    min-width: 20%;
    display:inline-block;
    position:relative;
    margin-bottom: 10px;
  }

  .optionListDivider {
    margin: 5px 0 !important;
  }

  .speech-text {
    padding:10px;
    bottom: 0;
    font-family: "Comic Sans MS" !important;
    text-align: center;
    vertical-align: center;
    max-width: 95%;
    min-width: 20%;
    display:inline-block;
    position:relative;
    margin-bottom: 10px;
    backdrop-filter: blur(10px);
    background-color: rgba(255, 255, 255, 0.80);
    color: black !important;
  }

  .speech-text_no-blur {
    padding:10px;
    bottom: 0;
    font-family: 'Montserrat', sans-serif !important;
    font-style: italic;
    text-align: center;
    vertical-align: center;
    max-width: 95%;
    min-width: 20%;
    display:inline-block;
    position:relative;
    margin-bottom: 10px;
  }

  [id^="vjs_video_"][class^="video-js"] {
    padding-top: 43.45% !important;
  }

  .fade-enter-active, .fade-leave-active {
    transition: opacity 0.25s ease-in-out;
  }

  .fade-enter, .fade-leave-to {
    opacity: 0;
  }

  .circular {
    width: 500px;
    height: 500px;
    background-size: cover;
  }

  #map {
    display: none;
  }

    #map .state {
      cursor: pointer;
    }

      #map .state .shape {
        cursor: pointer;
        -width: 0;
      }

      #map .state .label_icon_state {
        fill: #fff;
        font-family: Arial;
        font-size: 11px;
        line-height: 12px;
        font-weight: normal;
      }

      #map .state .label_state {
        display: none;
        font-family: Arial;
        font-size: 14px;
        line-height: 16px;
        font-weight: bold;
      }

      #map .state:hover .label_state, #map .state.hover .label_state {
        display: block;
      }

    #map .map-location .state .shape {
      fill: #ffffff;
      opacity: 0.4;
    }

    #map .map-location .state:hover .shape, #map .map-location .state.hover .shape .area {
      fill: #ffffff;
      opacity: 0.6;
    }

    #map .map-location .state:hover .icon_state, #map .map-location .state.hover .icon_state {
      fill: #5a95ce;
    }

    #map .map-location {
      animation: blinker 1.2s linear infinite;
      -webkit-animation: blinker 1.2s linear infinite;
    }
    .pagecounter{
      min-height:100%;
    }
    @keyframes blinker {
      0% { opacity: 1; }
      50% { opacity: 0; }
      100% { opacity: 1; }
    }

    @-webkit-keyframes blinker {
      0% { opacity: 1; }
      50% { opacity: 0; }
      100% { opacity: 1; }
    }

    .con-vs-popup.fullscreen .vs-popup {
      background-image: url('../../assets/images/blue backpack bg.png') !important;
      background-size: cover !important;
    }

    @media screen and (max-width: 830px) {
      .stack-divs {
        display: block !important;
      }

      .sm-full-width {
        width: 100% !important;
      }

      #backpack-contents-container {
        position: unset !important;
      }

      #backpack-notes-container {
        position: unset !important;
      }

      #inner-components-container {
        width: 100% !important;
      }
    }

    #logo-container {
      text-align: center;
      position: relative;
      margin-bottom: 25px;

      #autolinq-logo {
        width: 65%;
      }
    }

    #backpack-contents-container {
      z-index: 10000;
      position: absolute;
      display: block;
      text-align: left;
      left: 25px;
      right: 0;
    }

    @media screen and (min-width: 830px) {
      #backpack-contents-container.w-1\/2 {
        width: 48.5% !important;
      }

      #backpack-notes-container.w-1\/2 {
        width: 48.5% !important;
      }
    }
    
    .vs-component.vs-con-input-label.vs-input.w-full.mb-3.vs-input-primary {
      .vs-con-input{
        .vs-inputx.vs-input--input.normal {
          background-color: rgba(255, 255, 255, 0.4) !important;
        }
      }
    }

    #note-title {
      background: rgba(0, 0, 0, 0.4) !important;
      color: black !important
    }

    .transparent-bg {
      background-color: rgba(255, 255, 255, 0.4) !important;
    }

    .transparent-bg_black {
      background-color: rgba(0, 0, 0, 0.4) !important;
    }

    .vs-table--search-input {
      color: black !important
    }

    #backpack-notes-container {
      z-index: 10000;
      position: absolute;
      display: block;
      text-align: right;
      right: 25px;
    }

    #inner-components-container {
      border-radius: 5px;
      text-align: left;
      width: 100%;
      padding: 10px;
      bottom: 0;
      display: inline-block;
      position: relative;
      margin-bottom: 10px;
      -webkit-backdrop-filter: blur(10px);
      backdrop-filter: blur(10px);
      background-color: rgba(255, 255, 255, .25);
    }

    #backpack-popup {
      .rowcolor{
        background-color: rgba(255, 255, 255, 0) !important;
        font-weight: bold;
      }     

      .vs-con-table .vs-con-tbody {
        background-color: rgba(255, 255, 255, 0.1) !important;
        border: 0px solid #f8f8f8 !important;
      }

      .vs-pagination-primary .effect {
        background: rgba(114,114,114,1)!important;
      }

      .vs-pagination-primary .vs-pagination--buttons:hover {
        background: rgba(114,114,114,1)!important;
      }

      .vs-table--search-input {
        background-color: rgba(255, 255, 255, 0.3) !important;
      }
    }

    #textnavigation-card,
    #navigation-card,
    #podcast-card {
      .vx-card__collapsible-content {
        height: inherit !important;
      }
    }

    #help-btn-podcast { 
      position: absolute;
      bottom: 1;
      left: 1;
      z-index: 50000;
      margin-bottom: 5px;
      margin-left: 10px;
      &.vs-button.large .vs-button--icon {
        font-size: 1.75rem !important;
      }
    }

    #help-btn { 
      position: fixed !important;
      bottom: 0 !important;
      left: 0 !important;
      z-index: 50000;
      margin-bottom: 5px;
      margin-left: 10px;
      &.vs-button.large .vs-button--icon {
        font-size: 1.75rem !important;
      }
    }

    #doc-dwnld-btn { 
      position: fixed !important;
      top: 0 !important;
      right: 1% !important;
      z-index: 50000;
      margin-top: 60px;
      margin-right: 20px;
      &.vs-button.large .vs-button--icon {
        font-size: 1.75rem !important;
      }
    }

    .vjs_video_3-dimensions{
      height: 85vh !important;
      width: 95vw !important;
    }
    .vx-row{
      margin: 0;
      
  }
  .overflow-x-scroll{
    overflow-x: auto !important;
    padding-bottom: 20px;
  }
  .ag-center-cols-container{
      width: 100% !important;
  }

  @media screen and (max-width: 550px) {
    .pagecounter{
      min-height:83%;
    }
    .vue-slider-mark-label{
      font-size: 8px;
    }
    .textOptionSizing{
      overflow-y: auto;
      max-height: 50vh;
    }
  }

  .quiz-player.video-js{
    width:100% !important;
    height: 79vh;
  }

  #video-quiz-question-popup {
    h1, h2, h3, h4, h5, h6, p, span {
      color: black !important;
    }
    color: black !important;

    .vs-con-textarea {
      background: rgba(255, 255, 255, 1) !important;
    }
  }

  @media screen and (max-width: 900px) {

    .moibleview{
      
      background-repeat: no-repeat;
      background-size: auto;
      max-width: 100% !important;
      max-height: 90vh !important;
    }
    #formative-assessments-marked-popup{
      .vs-popup--background{
        background: black;
      }
    }
  }

  .centerpageviewer {
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
  }

  .back-button-margin-bottom-document{
    margin-bottom: 57px;
  }

  .next-button-margin-bottom-document{
    margin-bottom: 40px !important;
  }

  .video-quiz-question-popup-width{
    width: 240%;
  }

  @media screen and (max-width: 900px) {
    .video-quiz-question-popup-width{
      width: 100% !important;
    }
  }  

  .product-img
  {
    -webkit-filter: invert(100%);
  }

  #pdf-element {
    canvas {
      border-radius: 25px;
    }
    >span {
      margin-bottom: 1.3rem;
    }
  }

  .layout--main.navbar-hidden {
    overflow: hidden !important;
  }

  #uploadTask{
    #cover-filepond .filepond--drop-label > label, #book-filepond .filepond--drop-label > label, #video-filepond .filepond--drop-label > label, #podcast-filepond .filepond--drop-label > label{
      color: black !important;
      cursor: pointer;
    }
  }

</style>

<style type="stylesheet">
@import "https://unpkg.com/video.js/dist/video-js.min.css";
</style>